import React, { Component } from "react";
import "./sampleMobileApp.css";
import BackIcon from "../../../assets/images/MobileApp/back.png";
import LeftIcon from "../../../assets/images/MobileApp/logout.png";
import qr from "../../../assets/images/MobileApp/qr.png";
import addicon from "../../../assets/images/MobileApp/add-circle.svg";
import removeicon from "../../../assets/images/MobileApp/remove-circle.svg";
import Warning from "../../../assets/images/MobileApp/warning.svg"
import { signOut } from '../../../redux/action/main';
import Loading from "../../../components/Common/Loading";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  MeetingNotesServices,
  DevelopmentServices,
  SampleServices,
  UtilityService,
  CostingServices,
  CustomerServices,
  StyleServices,
  PermissionServices
} from "../../../services";
import  Async from "react-select";
import options from "../../../services/common/options";
import MobileAppFields from "./MobileAppFields";
import moment from "moment"
import MbModuleHeader from "./MbModuleHeader";
import MobileFileUpload from "./MobileFileUpload"
import MobileHeader from "./MobileHeader"


const allProceses = ["sample", "cad", "fabric", "trim", "pattern", "cutting", "sewing", "embellishment", "embroidery", "marker", "costing", "signOff", "dispatch", "garmentTechnologist", "qc", "wash"]
class SampleMobileApp extends Component {
  orgReqRef = React.createRef();
    state = {
      CADRefNumInfo:{},
      cuttingSizes:{},
      fabricList: [],
        toggles:{
            sample: false,
    trim: false,
    cutting: false,
    embellishment: false,
    wash: false,
    grading: false,
    marker: false,
    threeD: false,
    fabric: false,
    pattern: false,
    sewing: false,
    embroidery: false,
    dispatch: false,
    signOff: false,
        },
        isSample: false,
        is3D:false,
        isGarmentTech:false,
        isFabric:false,
        isTrim:false,
        isPattern:false,
        isCutting:false,
        isSewing:false,
        isMarker:false,
        isEmbellishment:false,
        isEmbroidery:false,
        isWash:false,
        isDispatch:false,
        isGrading:false,
        isCosting:false,
        isSignOff:false,
        showStickyHeader: false,
        is3DTextRef: React.createRef(),
        showStickyHeader: false,
        isLoading:true,
        sizes: [{ id: 1 }],
        fabric: [
          { id: 1 }
        ],
        logs: [{ id: 1 }],
        embellishment:[{id:1}],
        embroidery:[{id:1}],
        dispatch:[{id:1}],

        selectedOption: "not-in-use", // Default to "Not in Use"
        showUploadDiv: false,



        styleNoInfo: [],
    action: "",
    comments: "",
    _id: "",
    emptyData: null,
    selected: "sampleRequest",
    measurementChartData:{},
    sampleRequest: {
      requestNumber: null,
      qr: "",
      selectedType: "sampleRequest",
      originationOfRequest: null,
      magnumStyleId: null,
      typeOfRequest: "",
      sampleType: null,
      requiredDate: null,
      buyerName: "",
      assistantBuyer: "",
      fabricTechnologist: "",
      garmentTechnology: "",
      magnumTechnologist: null,
      customer: null,
      customerDepartmentId: null,
      orderDate: new Date(),
      styleReferenceId: null,
      magnumStyleName: "",
      customerRefNumber: "",
      test1:null,
      test2:"dsd",
      sample: {
        awaitingDevSample: false,
        awaitingDevSheet: false,
        data: [
          {
            size: null,
            quantity: null
          }
        ],
        comments: ""
      },
      cad: {
        cadId: null,
        cadName: "",
        cadRefNo: "",
        cadType: [],
        comments: ""
      },
      fabric: [],

      fabricRadio: "notInHse",
      trimRadio: "notInHse",
      trim: {
        // row1: [
        //   {
        //     trimId: null,
        //     trimCategory: null,
        //     trimNumber: null,
        //     description: "",
        //     size: "",
        //     quality: "",
        //     sizeNumber: "",
        //     trimRadio: "notInHse"
        //   }
        // ],
        smokingOrShiring: false,
        // row2: [
        //   {
        //     trimCategory: null,
        //     trimNumber: null,
        //     placement: null,
        //     number: null,
        //     type: null,
        //     noOfRow: null,
        //     length: null,
        //     totalReq: null
        //   }
        // ],
        comment: ""
      },
      pattern: {
        patternMaster: null,
        patternType: null,
        blockRefNumber: "",
        trailRequired: false,
        comment: "",
        date: null,
        existingBlockRefNumber: "",
        followedBlockRequired: false,
        approvalStatus: "",
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: ""
          }
        ]
      },

      cutting: {
        cuttingMasterName: null,
        cuttingType: null,
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: ""
          }
        ],
        comments: "",
        patternIssues: "",
        fabricIssues: false,
        approvalStatus: ""
      },
      sewing: {
        placeOfSewing: "5cde88716510d24851321273",
        sewingData: [
          {
            tailorName: null,
            sewingType: "5cde887e6510d24851321276",
            size: "",
            quantity: "",
            approvalStatus: "",
            rejected: "",
            logs: [
              // {
              //   remarks: "",
              //   timeIn: "",
              //   timeOut: "",
              //   breakTime: "",
              //   reason: ""
              // }
            ]
          }
        ],
        smokingOrShiring: false,
        trimData: [
          {
            trimCategory: null,
            trimNumber: null,
            placement: null,
            number: null,
            type: null,
            noOfRow: null,
            length: null,
            totalReq: null
          }
        ],

        comments: ""
      },
      embellishment: [
        {
          embType: null,
          hoursMinutes: null,
          pricePerHalfHour: null
        }
      ],
      embellishmentComments: "",
      embroidery: {
        cutPanel: false,
        allOver: false,
        garmentForm: false,
        semiGarmentForm: false,
        tassel: false,
        selected: [String],
        rightData: [],
        leftData: [],
        additionalInfo: "",
        refImages: [],
        employeeName: null,
        smocking: false,
        sheering: false,
        backing: false,
        bitAttaching: false,
        backingData: [
          {
            backingType: null,
            width: null,
            placement: null
          }
        ],
        embroideryData: [
          {
            embPlacement: null,
            embForm: null,
            noOfCols: null,
            frames: null,
            stitchesMtr: "",
            consumption: "",
            stitchCount: "",
            priceForStitches: ""
          }
        ],
        machine: [
          {
            frames: null,
            forms: null,
            placement: null,
            noOfCols: null,
            stitches: null,
            consumptions: null,
            StitchCount: null,
            price: null,
            backing: [
              {
                backing: "",
                width: null,
                placement: null
              }
            ]
          }
        ],
        comments: ""
      },
      garmentTechnologist: {
        // sampleForm: [
        //   {
        //     comments: "",
        //     fab: false,
        //     trims: false,
        //     workManShip: false,
        //     buyerChanges: false,
        //     pat: false,
        //     remarks: ""
        //   }
        // ],
        sampleForm: {
          fitMesurements: [],
          makeupConstruction: [],
          trimsComponents: [],
          packPresentation: []
        },
        garmentTechComments: "",
        markerRequirements: false,
        smvAmmendment: false,
        trailRequired: false,
        mock: false,
        comment: ""
      },
      wash: {
        washData: {
          washType: null,
          washFrom: "5d8c601cdd0f0307127f3770",
          laundryUnit: null,
          price: null
        },
        hasMock: false,
        numberOfMocks: null,
        tacking: false,
        recipe: true,
        refImages: [],
        comments: ""
      },
      dispatch: {
        magnumCounter: false,
        data: [
          // {
          //   location: null,
          //   date: null,
          //   courier: null,
          //   awbNumber: "",
          //   size: null,
          //   quantity: null
          // }
        ],
        comments: "",
        magnum: false
      },
      qc: {
        anyIssue: false,
        reason: "",
        refImages: [],
        comments: "",
        remarks: ""
      },
      marker: {
        refImages: [],
        comments: ""
      },
      costingComments: "",
      signOffComments: "",
      processUpdates: {
        sample: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        garmentTechnologist: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        cad: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        fabric: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        trim: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        pattern: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        cutting: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        sewing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        embellishment: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        embroidery: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        wash: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        dispatch: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        qc: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        marker: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        costing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },
        signOff: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        }
      },
      printLoading: false,
      fabricComments: "",
      toggle: {
        sample: true,
        cad: false,
        fabric: true,
        trim: true,
        pattern: true,
        cutting: true,
        sewing: true,
        garmentTechnologist: true,
        embellishment: false,
        embroidery: false,
        wash: false,
        dispatch: true,
        qc: true,
        marker: true,
        costing: true,
        signOff: true
      }
    },
    customerList:[],

    prefillInfo: {
      SAMPLEREQUEST: {},
      SAMPLE: {},
      CAD: {},
      FABRIC: {},
      TRIM: {},
      PATTERNTYPE: [],
      CUTTINGTYPE: [],
      STATUS: {},
      SEWING: {},
      SYSTEMSAMPLEREQUEST: {},
      EMBROIDERY: {},
      WASH: {},
      CUTTINGMASTER: [],
      PATTERNMASTER: [],
    },
    //isLoading: false,
    default: false,
    printGarmentLoading: false,
    printGarmentTech: {},
    assignedToList:[],

    assignedToListSewing: [],
    sizeList: [],
    assignedTo: {},
    row1List: [],
    row2List: [],
    rights: {},
    widthList: [],
    sampleMain: {},
    fabricList: [],
    customerDepartment: {},
    duplicateData: {
      processUpdates: {
        sample: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        garmentTechnologist: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        cad: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        fabric: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        trim: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        pattern: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        cutting: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        sewing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        embellishment: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        embroidery: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        wash: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        dispatch: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        qc: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        marker: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },

        costing: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        },
        signOff: {
          assignedTo: null,
          updatedBy: null,
          status: "PENDING",
          ETA: new Date(),
          processCompleted: false,
          processDate: null,
          comments: ""
        }
      },
      sample: {
        awaitingDevSample: false,
        awaitingDevSheet: false,
        data: [],
        sizes: [],
        comments: ""
      },
      cad: {
        cadId: null,
        cadName: "",
        cadRefNo: "",
        cadType: [],
        comments: ""
      },
      fabricRadio: "notInHse",
      trimRadio: "notInHse",
      pattern: {
        patternMaster: null,
        patternType: null,
        blockRefNumber: "",
        trailRequired: false,
        comment: "",
        date: null,
        existingBlockRefNumber: "",
        followedBlockRequired: false,
        approvalStatus: "",
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: ""
          }
        ]
      },

      cutting: {
        cuttingMasterName: null,
        cuttingType: null,
        logs: [
          {
            remarks: "",
            timeIn: "",
            timeOut: "",
            breakTime: "",
            reason: ""
          }
        ],
        comments: "",
        patternIssues: "",
        fabricIssues: false,
        approvalStatus: ""
      },
      sewing: {
        placeOfSewing: "5cde88716510d24851321273",
        sewingData: [
          {
            tailorName: null,
            sewingType: "5cde887e6510d24851321276",
            size: "",
            quantity: "",
            approvalStatus: "",
            rejected: "",
            logs: [
              // {
              //   remarks: "",
              //   timeIn: "",
              //   timeOut: "",
              //   breakTime: "",
              //   reason: ""
              // }
            ]
          }
        ],
        smokingOrShiring: false,
        trimData: [
          {
            trimCategory: null,
            trimNumber: null,
            placement: null,
            number: null,
            type: null,
            noOfRow: null,
            length: null,
            totalReq: null
          }
        ],

        comments: ""
      },
      embellishment: [
        {
          embType: null,
          hoursMinutes: null,
          pricePerHalfHour: null
        }
      ],
      embellishmentComments: "",
      embroidery: {
        cutPanel: false,
        allOver: false,
        garmentForm: false,
        semiGarmentForm: false,
        tassel: false,
        selected: [String],
        rightData: [],
        leftData: [],
        additionalInfo: "",
        refImages: [],
        employeeName: null,
        smocking: false,
        sheering: false,
        backing: false,
        bitAttaching: false,
        backingData: [
          {
            backingType: null,
            width: null,
            placement: null
          }
        ],
        embroideryData: [
          {
            embPlacement: null,
            embForm: null,
            noOfCols: null,
            frames: null,
            stitchesMtr: "",
            consumption: "",
            stitchCount: "",
            priceForStitches: ""
          }
        ],
        machine: [
          {
            frames: null,
            forms: null,
            placement: null,
            noOfCols: null,
            stitches: null,
            consumptions: null,
            StitchCount: null,
            price: null,
            backing: [
              {
                backing: "",
                width: null,
                placement: null
              }
            ]
          }
        ],
        comments: ""
      },
      garmentTechnologist: {
        sampleForm: {
          fitMesurements: [],
          makeupConstruction: [],
          trimsComponents: [],
          packPresentation: []
        },
        garmentTechComments: "",
        markerRequirements: false,
        smvAmmendment: false,
        trailRequired: false,
        mock: false,
        comment: ""
      },
      dispatch: {
        magnumCounter: false,
        data: [
          // {
          //   location: null,
          //   date: null,
          //   courier: null,
          //   awbNumber: "",
          //   size: null,
          //   quantity: null
          // }
        ],
        comments: "",
        magnum: false
      },
      qc: {
        anyIssue: false,
        reason: "",
        refImages: [],
        comments: "",
        remarks: ""
      },
      marker: {
        refImages: [],
        comments: ""
      },
    }
    }
    textRefs = {
      isSample: React.createRef(),
      isGarmentTech: React.createRef(),
      is3D: React.createRef(),
      isFabric: React.createRef(),
      isTrim: React.createRef(),
      isPattern: React.createRef(),
      isCutting: React.createRef(),
      isSewing: React.createRef(),
      isMarker: React.createRef(),
      isEmbellishment: React.createRef(),
      isEmbroidery: React.createRef(),
      isWash: React.createRef(),
      isDispatch: React.createRef(),
      isGrading: React.createRef(),
      isCosting: React.createRef(),
      isSignOff: React.createRef(),
    };



    async componentWillMount(){
      // let sampleRequest = { ...this.state.sampleRequest };
      //console.log(this.props.location.state._id,"props")
      let _id = this.props.location.state._id || ""
      await SampleServices.SampleInfo(_id).then(response => {
                if (response.status == 200) {
               
                  this.setState({ sampleRequest: response.text.data });
                  let sampleRequest = { ...this.state.sampleRequest };
             
                  if (response.text.data.sample.data.length === 0) {
                    sampleRequest.sample.data = [
                      {
                        size: null,
                        quantity: null
                      }
                    ];
                  }
      
                  if (
                    response.text.data.garmentTechnologist.sampleForm.length === 0
                  ) {
                    sampleRequest.garmentTechnologist.sampleForm = [
                      {
                        comments: "",
                        fab: false,
                        trims: false,
                        workManShip: false,
                        buyerChanges: false,
                        pat: false,
                        remarks: ""
                      }
                    ];
                  }
      
                  if (response.text.data.pattern.logs.length === 0) {
                    sampleRequest.pattern.logs = [
                      {
                        remarks: "",
                        timeIn: "",
                        timeOut: "",
                        breakTime: "",
                        reason: ""
                      }
                    ];
                  }
                  
      
                  if (response.text.data.cutting.logs.length === 0) {
                    sampleRequest.cutting.logs = [
                      {
                        remarks: "",
                        timeIn: "",
                        timeOut: "",
                        breakTime: "",
                        reason: ""
                      }
                    ];
                  }
      
                  sampleRequest.processUpdates = {
                    ...response.text.data.processUpdates
                  };
      
                  this.getMagnumStyleById(sampleRequest.styleReferenceId);
                  this.setState(
                    {
                      sampleRequest,
                      _id: response.text.data._id,
                      createdAt: response.text.data.createdAt
                    },
                    () => {
                      //this.getAssignedTo()
                      this.getStyleReferenceInfo(
                        this.state.sampleRequest.styleReferenceId
                      );
                    }
                  );
                }
              });

              await CustomerServices.customerInfo()
                    .then(response => {
                      //console.log(response.message,"mess")
                      if (response.text.message == "all customer details") {
                        //console.log(response,"res")
                        this.setState({
                          customerList: response.text.data
                          // customerId: response.data[0]._id,
                          // departmentId: response.data[0].departmentId
                        });
                      }
                    })
                    .catch(error => {
                      this.props.getalertMessage("error", error.toString());
                    });
                    await this.waitForStateToUpdate();

                    await SampleServices.prefillSRDetails()
                          .then(response => {
                            if (response.message === "Operation Successful") {
                            
                              let sampleRequest = { ...this.state.sampleRequest };
                             
                              
                              sampleRequest.embroidery.leftData = [
                                ...response.data.SYSTEMSAMPLEREQUEST.LEFTVALUES
                              ];
                              this.setState({
                                sampleRequest,
                                // sampleRequestType,
                                prefillInfo: response.data,
                                styleInfo: response.data.Style,
                                fabricInfo: response.data.Fabric,
                                trimInfo: response.data.Trims
                              });
                    
                               
                                let prefillInfo = this.state.prefillInfo;
                                // Trim Category for Trim Module
                                let trimCategory =
                                  prefillInfo.TRIM.TRIMCATEGORY &&
                                  prefillInfo.TRIM.TRIMCATEGORY.filter(
                                    x => x.label.toLowerCase() === "thread"
                                  )[0].value;
                                // Trim Category for Sewing Module
                                let trimCategorySewing =
                                  prefillInfo.TRIM.TRIMCATEGORY &&
                                  prefillInfo.TRIM.TRIMCATEGORY.filter(
                                    x => x.label.toUpperCase() === "THREAD ELASTIC"
                                  )[0];
                                // sampleRequest.trim.row1 = sampleRequest.trim.row1.map(x => {
                                //   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
                                //   return x
                                // })
                                // sampleRequest.trim.row2 = sampleRequest.trim.row2.map(x => {
                                //   x.trimCategory = x.trimCategory ? x.trimCategory : trimCategory
                                //   return x
                                // })
                                sampleRequest.sewing.trimData = sampleRequest.sewing.trimData.map(
                                  x => {
                                    x.trimCategory = x.trimCategory
                                      ? x.trimCategory
                                      : trimCategorySewing;
                                    return x;
                                  }
                                );
                                // if (
                                //   sampleRequest.trim &&
                                //   sampleRequest.trim.row1 &&
                                //   sampleRequest.trim.row1.length > 0
                                // ) {
                                //   sampleRequest.trim.row1.forEach((x, i) => {
                                //     if (x.trimCategory) {
                                //       SampleServices.getTrimNumber(x.trimCategory)
                                //         .then(async response => {
                                //           sampleRequest.trim.row1[i].trimList = response.text.data
                                //         })
                                //         .catch(error => alert(error.toString()))
                                //     }
                                //   })
                                // }
                    
                                if (
                                  sampleRequest.sewing &&
                                  sampleRequest.sewing.trimData &&
                                  sampleRequest.sewing.trimData.length
                                ) {
                                  sampleRequest.sewing.trimData.forEach((x, i) => {
                                    if (x.trimCategory) {
                                      SampleServices.getTrimNumber(x.trimCategory)
                                        .then(async response => {
                                          sampleRequest.sewing.trimData[i].trimList =
                                            response.text.data;
                                        })
                                        .catch(error => alert(error.toString()));
                                    }
                                  });
                                }
                    
                                // if (
                                //   sampleRequest.trim &&
                                //   sampleRequest.trim.row2 &&
                                //   sampleRequest.trim.row2.length > 0
                                // ) {
                                //   sampleRequest.trim.row2.forEach((x, i) => {
                                //     if (x.trimCategory) {
                                //       SampleServices.getTrimNumber(x.trimCategory)
                                //         .then(async response => {
                                //           sampleRequest.trim.row2[i].trimList = response.text.data
                                //         })
                                //         .catch(error => alert(error.toString()))
                                //     }
                                //   })
                                // }
                    
                                // sampleRequest.wash.washData[0].price =
                                //   prefillInfo.WASH.PRICEPERKG[0].label
                                // sampleRequest.wash.washData = sampleRequest.wash.washData.map((x)=>{
                                //   x.price = x.price ? x.price : prefillInfo.WASH.PRICEPERKG[0].label
                                // })
                                // this.setState({ sampleRequest })
                              
                            }
                          })
                          .catch(error => {
                            this.props.getalertMessage("error", error.toString());
                          });



                          await SampleServices.getCustomerData({
                                    customer:this.state.sampleRequest && this.state.sampleRequest.customer ,
                                    customerDepartmentId:this.state.sampleRequest && this.state.sampleRequest.customerDepartmentId,
                                    type: this.state.sampleRequest && this.state.sampleRequest.typeOfRequest
                                  }) 
                                    .then(response => {
                                      if (response.status == 200) {
                                      
                                        
                                        this.setState({
                                          sizeList: response.text.data.sizes
                                        });
                                      }
                                    })
                                    .catch(error =>
                                      this.props.getalertMessage("error hell", error.toString())
                                    );

                                    this.getCADRefNumber("")

                    
                    
    }
    waitForStateToUpdate = () => {
      return new Promise(resolve => {
        const checkState = () => {
          if (this.state.sampleRequest.customer && this.state.sampleRequest.customerDepartmentId) {
            resolve(); // Resolve the promise if the state is correct
          } else {
            setTimeout(checkState, 50); // Check again after a short delay
          }
        };
        checkState();
      });
    };
    componentDidMount(){
      window.addEventListener("scroll", this.handleScroll);
    //   this.handleTouchMove = (event) => {
    //     if (event.scale !== 1) {
    //         event.preventDefault();
    //     }
    // };

    // document.addEventListener("touchmove", this.handleTouchMove, { passive: false });
      // CustomerServices.customerInfo()
      //       .then(response => {
      //         if (response.status === 200) {
      //           this.setState({
      //             customerList: response.text.data
      //             // customerId: response.data[0]._id,
      //             // departmentId: response.data[0].departmentId
      //           });
      //         }
      //       })
      //       .catch(error => {
      //         this.props.getalertMessage("error", error.toString());
      //       });
       SampleServices.getCustomerData({
        customer:this.state.sampleRequest && this.state.sampleRequest.customer ,
        customerDepartmentId:this.state.sampleRequest && this.state.sampleRequest.customerDepartmentId,
        type: this.state.sampleRequest && this.state.sampleRequest.typeOfRequest
      }) 
        .then(response => {
          if (response.status == 200) {
          
            
            this.setState({
              sizeList: response.text.data.sizes
            });
          }
        })
        .catch(error =>
          this.props.getalertMessage("error hell", error.toString())
        );


        let data1 = [];

        if (this.state.sampleRequest && this.state.sampleRequest.sample && this.state.sampleRequest.sample.data) {
          data1 = this.state.sampleRequest.sample.data
            .filter(x => x.size) // Ensures only valid sizes are processed
            .map(x => ({ label: x.size })); // Transforms the array
        }
        
        this.setState({ cuttingSizes: data1 });


      DevelopmentServices.prefillDataCadSystem().then(res => {
            if (res.status === 200) {
              this.setState({
                cadPreFill: {
                  CADTYPE: res.text.data.CADTYPE,
                  PRINTEMBTYPE: res.text.data.PRINTEMBTYPE,
                  BORDERTYPE: res.text.data.BORDERTYPE
                }
              });
            }
          });


          DevelopmentServices.getFabricNumber("")
                          .then(response => {
                            if (response.status == 200) {
                              this.setState({ fabricList: response.text.data });
                            }
                          })
                          .catch(error => { });

            // Hide loader after 5 seconds
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 5000);

    // this.getMagnumStyleNo("");
    
      
    }
    // componentDidUpdate(prevProps, prevState) {
    //   if (this.state.is3D && !prevState.is3D) {
    //     if (this.state.is3DTextRef.current) {
    //       this.state.is3DTextRef.current.focus();
    //     }
    //   }
    // }
    // componentDidMount() {
      
    // }
    
    componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
      // document.removeEventListener("touchmove", this.handleTouchMove);
    }
    
    handleScroll = () => {
      if (this.orgReqRef.current) {
        const rect = this.orgReqRef.current.getBoundingClientRect();
        this.setState({ showStickyHeader: rect.bottom <= 0 });
      }
    };
    


    getMagnumStyleById = value => {
        DevelopmentServices.getMagnumStyleNoWithReferenceById(value)
          .then(response => {
            if (response.status === 200) {
              this.setState({ styleNoInfo: response.text.data });
              //console.log('this.setState', 'response.text.data:', response.text.data);

            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()));
      };


      createSample = () => {
          let sampleRequestData = Object.assign({}, this.state.sampleRequest);
      
          Object.keys(sampleRequestData).forEach((x) => {
            if (allProceses.includes(x)) {
              delete sampleRequestData[x]
            }
          })
      
          sampleRequestData.requiredDate = new Date();
      
          if (this.state._id !== "") {
            sampleRequestData._id = this.state._id;
          } else {
            delete sampleRequestData._id;
          }
          SampleServices.createSampleRequest(sampleRequestData)
            .then(res => {
              if (res.status === 200) {
                let sampleRequest = { ...this.state.sampleRequest }
                sampleRequest.qr = res.text.data.qr
                sampleRequest.requestNumber = res.text.data.requestNumber
                sampleRequest.createdAt = res.text.data.createdAt
      
                this.props.getalertMessage("success", res.text.message);
      
                // this.props.history.replace('/Sample', {
                //   action: 'edit',
                //   _id: res.text.data._id
                // })
                this.setState(
                  {
                    _id: res.text.data._id,
                    createdAt: res.text.data.createdAt,
                    sampleRequest
                  },
                  // () => this.getAssignedTo()
                );
              } else {
                let required = [
                  "originationOfRequest",
                  "magnumStyleId",
                  "typeOfRequest",
                  "sampleType",
                  "buyerName",
                  "assistantBuyer"
                ].filter(x => {
                  if (
                    this.state.sampleRequest[x] === "" ||
                    this.state.sampleRequest[x] === undefined ||
                    this.state.sampleRequest[x] === null
                  ) {
                    return x;
                  }
                });
                this.props.getalertMessage("info", `${required[0]} Required`);
              }
              res.status === 401 && this.props.unauthorisedFunc();
            })
            .catch(error => this.props.getalertMessage("error", error.toString()));
        };


        updateModulesMain = async (name, value, moduleName) => {
          let sampleRequest = { ...this.state.sampleRequest };
          if (name === "status" && value === "COMPLETED" && ['pattern', 'cutting', 'sewing', 'dispatch'].includes(moduleName)) {
            const { isErr, message } = await this.shouldTodo(name, value, moduleName, sampleRequest)
            if (isErr)
              return this.props.getalertMessage('error', message, 5000)
          }
          if (name == "assignedTo") {
            sampleRequest.processUpdates[moduleName][name] =
              value !== null ? value.value : null;
          } else if (name == "status") {
            sampleRequest.processUpdates[moduleName][name] = value;
            if (value === "COMPLETED") {
              sampleRequest.processUpdates[moduleName].processDate = new Date();
            }
          } else {
            sampleRequest.processUpdates[moduleName][name] = value;
          }
          this.setState({
            sampleRequest
          });
        };

        

        getMagnumStyleNo = value => {
            DevelopmentServices.getMagnumStyleNoWithReference(value)
              .then(response => {
                if (response.status === 200) {
                  let jsonData = [];
                  response.text.data.map((info, index) => {
                    let objData = {};
                    objData.label = info.referenceCode;
                    objData.value = info.referenceId;
                    jsonData.push(objData);
                  });
                  this.setState({ styleNoInfo: jsonData });
                }
              })
              .catch(error => {
                // Handle error if needed
                console.error("Error fetching style info:", error);
              });
              //console.log(this.state.styleNoInfo.map(va=>va.label),"styleInf")
          };
        

      


      getStyleReferenceInfo = value => {
          if (value !== null) {
            this.setState({
              isLoading: true
            });
            let { sampleRequest, measurementChartData } = this.state;
            sampleRequest.styleReferenceId = value;
            StyleServices.getStyleInfoByReference(value)
              .then(response => {
                if (response.status === 200) {
                  sampleRequest.magnumStyleName = response.text.data.magnumStyleName;
                  measurementChartData.magnumStyleName = response.text.data.magnumStyleName;
                  sampleRequest.customerRefNumber =
                    response.text.data.customerRefNumber;
                  measurementChartData.customerRefNumber = response.text.data.customerRefNumber;
                  sampleRequest.magnumStyleId = response.text.data.magnumStyleId;
                  measurementChartData.magnumStyleId = response.text.data.magnumStyleId;
                  sampleRequest.customer = response.text.data.customer;
                  measurementChartData.customer = response.text.data.customer;
                  sampleRequest.customerDepartmentId =
                    response.text.data.customerDepartmentId;
                  measurementChartData.customerDepartmentId = response.text.data.customerDepartmentId;
                  sampleRequest.itemNumber = response.text.data.itemNumber;
                  measurementChartData.itemNumber = response.text.data.itemNumber;
                  sampleRequest.blockRefNo = response.text.data.blockRefNumber;
                  measurementChartData.blockRefNo = response.text.data.blockRefNumber;
                  sampleRequest.oldMagStyleNo = response.text.data.refDetail;
                  measurementChartData.oldMagStyleNo = response.text.data.refDetail;
                  sampleRequest.refColNo = response.text.data.referenceColor;
                  measurementChartData.refColNo = response.text.data.referenceColor;
                  sampleRequest.magnumBuyerStyleName =
                    response.text.data.magnumBuyerStyleName;
                  measurementChartData.magnumBuyerStyleName = response.text.data.magnumBuyerStyleName;
                  this.setState(
                    {
                      sampleRequest,
                      measurementChartData
                    },
                    () =>
                      this.getMainValues(
                        sampleRequest.customer,
                        sampleRequest.customerDepartmentId
                      )
                  );
                  //console.log(this.state.sampleRequest, "sampleRequest");
                }
                response.status == 401 && this.props.unauthorisedFunc();
              })
              .catch(error => this.props.getalertMessage("error", error.toString()));
          } else {
            let sampleRequest = { ...this.state.sampleRequest };
            sampleRequest.styleReferenceId = null;
            this.setState({
              sampleRequest
            });
          }
        };

        getMainValues = async (customer, customerDepartmentId) => {
            if (customer == null || customerDepartmentId == null) {
              let sample = this.state.sampleRequest;
              sample.styleReferenceId = null;
              this.setState({
                sampleRequest: sample,
                //isLoading: false
              });
              this.props.getalertMessage(
                "error",
                "Selected Magnum Styleref have invalid data"
              );
            }
        
            await SampleServices.getCustomerData2({
              customer: customer,
              customerDepartmentId: customerDepartmentId
            })
              .then(async response => {
                if (response.status == 200) {
                
                  let sampleRequest = { ...this.state.sampleRequest };
                  sampleRequest.assistantBuyer = response.text.data.asstbuyer;
                  sampleRequest.buyerName = response.text.data.buyer;
                  sampleRequest.fabricTechnologist = response.text.data.fabtech;
                  sampleRequest.garmentTechnology = response.text.data.gmttech;
                  sampleRequest.magnumTechnologist =
                    response.text.data.garmentTechnologist;
                  this.setState({
                    sampleRequest,
                    //isLoading: false
                  });
                }
              })
              .catch(error => {
                this.setState({
                  //isLoading: false
                });
                this.props.getalertMessage("error", error.toString());
              });
          };


    handleAddSize = () => {
      this.setState((prevState) => ({
        sizes: [...prevState.sizes, { id: prevState.sizes.length + 1 }],
      }));
    };

    handleRemoveSize = (id) => {
      this.setState((prevState) => ({
        sizes: prevState.sizes.filter((size) => size.id !== id),
      }));
    };

    handleRadioChange = (event) => {
      this.setState({ selectedOption: event.target.value });
    };

    handleAddLog = () => {
      this.setState((prevState) => ({
        logs: [...prevState.logs, { id: prevState.logs.length + 1 }]
      }));
    };

    handleLogRemove = (id) => {
      this.setState((prevState) => ({
        logs: prevState.logs.filter((size) => size.id !== id),
      }));
    };


    handleAddSection = () => {
      this.setState((prevState) => ({
        fabric: [...prevState.fabric, { id: prevState.fabric.length + 1 }]
      }));
    };

    handleRemovefabric = (id) => {
      this.setState((prevState) => ({
        fabric: prevState.fabric.filter((fabric) => fabric.id !== id),
      }));
    };


    handleAddDispatch = () => {
      this.setState((prevState) => ({
        dispatch: [...prevState.dispatch, { id: prevState.dispatch.length + 1 }]
      }));
    };

    handleRemovedispatch = (id) => {
      this.setState((prevState) => ({
        dispatch: prevState.dispatch.filter((dispatch1) => dispatch1.id !== id),
      }));
    };


    handleAddEmbroidery = () => {
      this.setState((prevState) => ({
        embroidery: [...prevState.embroidery, { id: prevState.embroidery.length + 1 }]
      }));
    };

    handleRemoveEmbroidery = (id) => {
      this.setState((prevState) => ({
        embroidery: prevState.embroidery.filter((embroidery) => embroidery.id !== id),
      }));
    };


    handleAddEmbSection = () => {
      this.setState((prevState) => ({
        embellishment: [...prevState.embellishment, { id: prevState.embellishment.length + 1 }]
      }));
    };

    handleRemoveEmb = (id) => {
      this.setState((prevState) => ({
        embellishment: prevState.embellishment.filter((emb) => emb.id !== id),
      }));
    };


    handleToggleUpload = () => {
      this.setState({ showUploadDiv: true });
    };
  
    handleCancelUpload = () => {
      this.setState({ showUploadDiv: false });
    };

    handleToggle = (field) =>{
        this.setState((prevState)=>({
            toggles:{
                ...prevState.toggles,
                [field]: !prevState.toggles[field],
            }
        }))
    }
    // handleToggleDropdown = (key) =>{
    //     this.setState((prevState)=>({
    //         [key]: !prevState[key],
    //     }))
    // };


  //   handleToggleDropdown = (key) => {
  //     this.setState((prevState) => {
  //         // If the clicked key is already open, close it
  //         const isCurrentlyOpen = prevState[key];
          
  //         return {
  //             isSample: false,
  //             is3D: false,
  //             isFabric: false,
  //             isTrim: false,
  //             isPattern: false,
  //             isCutting: false,
  //             isSewing: false,
  //             isMarker: false,
  //             isEmbellishment: false,
  //             isEmbroidery: false,
  //             isWash: false,
  //             isDispatch: false,
  //             isGrading: false,
  //             isSignOff: false,
  //             [key]: !isCurrentlyOpen, // Toggle only the clicked key
  //         };
  //     });
  // }


  handleToggleDropdown = (key) => {
    this.setState((prevState) => {
      const isCurrentlyOpen = prevState[key];

      return {
        isSample: false,
        isGarmentTech:false,
        is3D: false,
        isFabric: false,
        isTrim: false,
        isPattern: false,
        isCutting: false,
        isSewing: false,
        isMarker: false,
        isEmbellishment: false,
        isEmbroidery: false,
        isWash: false,
        isDispatch: false,
        isGrading: false,
        isCosting:false,
        isSignOff: false,
        [key]: !isCurrentlyOpen, // Toggle only the clicked key
      };
    }, () => {
      // Focus on the text span after the state update
      if (this.state[key] && this.textRefs[key].current) {
        this.textRefs[key].current.focus();
      }
    });
  };
  


    updateSampleRequest = (name, value) => {
  

      let sampleRequest = { ...this.state.sampleRequest };
      sampleRequest[name] = value;
  
      this.setState({
        sampleRequest
      });
    };


    // updateSampleRequest = (name, value) => {
    //   this.setState((prevState) => ({
    //     sampleRequest: {
    //       ...prevState.sampleRequest,
    //       [name]: value, // Dynamically updates the correct key
    //     },
    //   }));
    // };


    //toggle update
  // toggleChange = (name, value) => {
  //   let sampleRequest = { ...this.state.sampleRequest };
  //   sampleRequest.toggle[name] = value;
  //   this.setState([sampleRequest]);
  // };


  toggleChange = (key) => {
    this.setState((prevState) => {
      let sampleRequest = { ...prevState.sampleRequest };
  
      // Ensure 'toggle' exists
      if (!sampleRequest.toggle) {
        sampleRequest.toggle = {};
      }
  
      // Toggle the value
      sampleRequest.toggle[key] = !sampleRequest.toggle[key];
  
      return { sampleRequest };
    });
  };

  updateSampleModule = (name, value, Dataindex) => {
    let { sampleRequest } = this.state;
    if (Dataindex !== undefined) {
      sampleRequest.sample.data[Dataindex][name] = value;
    } else {
      sampleRequest.sample[name] = value;
    }
    this.setState({
      sampleRequest
    });
  };


  addSize = () => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sample.data.push({ size: null, quantity: null });
    this.setState({ sampleRequest });
  };


  removeSize = dataIndex => {
    let sampleRequest = { ...this.state.sampleRequest };
    sampleRequest.sample.data.splice(dataIndex, 1);
    this.setState({ sampleRequest });
  };

  createSampleModule = e => {
      e.preventDefault();
      let sample = {};
      sample.sample = { ...this.state.sampleRequest.sample };
      sample.sampleProcess = {
        ...this.state.sampleRequest.processUpdates.sample
      };
      sample._id = this.state._id;
      SampleServices.createSample(sample)
        .then(response => {
          if (response.status === 200) {
            let sampleRequest = { ...this.state.sampleRequest };
            sampleRequest.sample = response.text.data;
  
            this.setState({
              sampleRequest
            });
            this.props.getalertMessage("success", response.text.message);
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()));
    };

    completeSampleModule = e => {
        let sampleRequest = { ...this.state.sampleRequest };
        let request = {
          _id: this.state._id,
          comments: sampleRequest.processUpdates.sample.comments
        };
        SampleServices.completeSample(request)
          .then(response => {
            if (response.status === 200) {
              sampleRequest.processUpdates.sample = { ...response.text.data };
              this.setState({
                sampleRequest
              });
              this.props.getalertMessage("success", response.text.message);
            } else if (response.status == 401) {
              this.props.unauthorisedFunc();
            } else {
              this.props.getalertMessage("error", response.text.message);
            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()));
      };

      getCADRefNumber = value => {
          DevelopmentServices.getCADRefNumber(value)
            .then(response => {
              if (response.status === 200) {
                this.setState({ CADRefNumInfo: response.text.data })
              }
            })
            .catch(error => { })
        }



        changeCADRefNum = cad => {
            let sampleRequest = { ...this.state.sampleRequest };
        
            if (cad !== null) {
              DevelopmentServices.getCAD(cad.value)
                .then(async response => {
                  if (response.status == 200) {
                    sampleRequest.cad.cadType = response.text.data.cadType;
                    sampleRequest.cad.cadId = cad.value;
                    sampleRequest.cad.name = response.text.data.cadName;
                    sampleRequest.cad.printEmbType = response.text.data.printType;
                    sampleRequest.cad.borderType = response.text.data.borderType;
                  }
                })
                .catch(error => this.props.getalertMessage("error", error.toString()));
            } else {
              sampleRequest.cad.cadType = [];
              sampleRequest.cad.cadId = null;
              sampleRequest.cad.name = "";
              sampleRequest.cad.printEmbType = "";
              sampleRequest.cad.borderType = "";
            }
            setTimeout(() => {
              this.setState({
                sampleRequest
              });
            }, 100);
          };


          cadUpdate = (...args) => {
            const cad = { ...this.state.sampleRequest.cad };
            const name = args[0];
            const value = args[1];
            cad[name] = value;
        
            this.setState({
              sampleRequest: {
                ...this.state.sampleRequest,
                cad
              }
            });
          };

          updateCadValues = (name, value) => {
            let sampleRequest = { ...this.state.sampleRequest };
            sampleRequest.cad[name] = value;
            this.setState({
              sampleRequest
            });
          };


          saveCAD = e => {
              e.preventDefault();
              let cad = {};
              cad.cad = this.state.sampleRequest.cad;
              cad.cadProcess = this.state.sampleRequest.processUpdates.cad;
              cad._id = this.state._id;
              SampleServices.createCAD(cad)
                .then(response => {
                  if (response.status === 200) {
                    let sampleRequest = { ...this.state.sampleRequest };
                    sampleRequest.cad = response.text.data;
                    this.setState({
                      sampleRequest
                    });
                    this.props.getalertMessage("success", response.text.message);
                  }
                })
                .catch(error => this.props.getalertMessage("error", error.toString()));
            };

            completeCAD = () => {
                let sampleRequest = { ...this.state.sampleRequest };
                let request = {
                  _id: this.state._id,
                  comments: sampleRequest.processUpdates.cad.comments
                };
                SampleServices.completeCAD(request)
                  .then(response => {
                    if (response.status === 200) {
                      sampleRequest.processUpdates.cad = { ...response.text.data };
                      this.setState({
                        sampleRequest
                      });
                      this.props.getalertMessage("success", response.text.message);
                    } else if (response.status == 401) {
                      this.props.unauthorisedFunc();
                    } else {
                      this.props.getalertMessage("error", response.text.message);
                    }
                  })
                  .catch(error => this.props.getalertMessage("error", error.toString()));
              };


              addFabric = () => {
                  let sampleRequest = { ...this.state.sampleRequest };
                  if (!sampleRequest.fabric.length) {
                    DevelopmentServices.getFabricNumber("F-99999")
                      .then(response => {
                        if (response.status == 200) {
                          sampleRequest.fabric.push({
                            fabricId: null,
                            fabricNumber: "",
                            fabricList: response.text.data,
                            fabricPosition: null,
                            classificationOfFabric: "",
                            quality: "",
                            countAndConstruction: "",
                            fabricRadio: "notInHse"
                          });
                          // this.setState({ fabricList: response.text.data })
                          this.getFabricInfo(response.text.data[0], 0);
                        }
                      })
                      .catch(error => { });
                  } else {
                    sampleRequest.fabric.push({
                      fabricId: null,
                      fabricNumber: "",
                      fabricList: this.props.fabricList,
                      fabricPosition: null,
                      classificationOfFabric: "",
                      quality: "",
                      countAndConstruction: "",
                      fabricRadio: "notInHse"
                    });
                  }
              
                  this.setState({
                    sampleRequest
                  });
                };


                removeFabric = index => {
                  let sampleRequest = { ...this.state.sampleRequest };
                  sampleRequest.fabric.splice(index, 1);
                  this.setState({
                    sampleRequest
                  });
                };


                getFabricNumber = (value, index) => {
                    // alert(1)
                    DevelopmentServices.getFabricNumber(value)
                      .then(response => {
                        if (response.status == 200) {
                          // this.setState({ fabricList: response.text.data })
                          let sampleRequest = { ...this.state.sampleRequest };
                          if (sampleRequest.fabric.length) {
                            sampleRequest.fabric[index].fabricList = response.text.data;
                            this.setState({ sampleRequest });
                          }
                        }
                      })
                      .catch(error => { });
                  };


                  getFabricInfo = (fabric, index) => {
                      if (fabric != null) {
                        SampleServices.getFabricInfo(fabric.value)
                          .then(async response => {
                            if (response.status == 200) {
                            
                              let sampleRequest = { ...this.state.sampleRequest };
                             
                              sampleRequest.fabric[index].classificationOfFabric =
                                response.text.data.classificationOfFabric !== null
                                  ? response.text.data.classificationOfFabric.name
                                  : "";
                              sampleRequest.fabric[
                                index
                              ].countAndConstruction = `${response.text.data.count.warp}*${response.text.data.count.weft}/${response.text.data.construction.warp}*${response.text.data.construction.weft}`;
                              sampleRequest.fabric[index].quality =
                                response.text.data.quality !== null
                                  ? response.text.data.quality.name
                                  : "";
                              sampleRequest.fabric[index].fabricNumber = fabric.value;
                              sampleRequest.fabric[index].bNumber = response.text.data.bNumber.baseRefNumber;
                              sampleRequest.test1 = response.text.data.bNumber.baseRefNumber;
                              this.setState({
                                sampleRequest
                              });
                            }
                            response.status == 404 &&
                              this.props.getalertMessage("error", response.text.message);
                            response.status == 401 && this.props.unauthorisedFunc();
                          })
                          .catch(error => { });
                      } else {
                        let sampleRequest = { ...this.state.sampleRequest };
                        //console.log(this.sampleRequest.fabric,"test fab")
                        sampleRequest.fabric[index].fabricNumber = null;
                        this.setState({
                          sampleRequest
                        });
                      }
                    };



                    updateFabricName = (name, value,index) => {
  

                      let sampleRequest = { ...this.state.sampleRequest };
                      //console.log(sampleRequest, "sampleRequestname");
                      sampleRequest.fabric[index][name] = value;
                      //console.log(sampleRequest.fabric[index][name], "sampleRequestname1212");
                  
                      this.setState({
                        sampleRequest
                      });
                    };



                    updateFabric = (name, value, index) => {
                      let sampleRequest = { ...this.state.sampleRequest };
                      sampleRequest.fabric[index][name] = value;
                      this.setState({
                        sampleRequest
                      });
                    };



                    checkValidation = (data, element) => {
                      // console.log(this.validateArrayObject(this.props.fabric , 'fabricPosition', null), "fabricPosition")
                      // console.log(this.validateArrayObject(this.props.fabric , 'fabricNumber', null ), "fabricNumber")
                  
                      if (
                        this.validateArrayObject(this.state.sampleRequest.fabric, "fabricPosition", null) &&
                        (this.validateArrayObject(this.state.sampleRequest.fabric, "fabricNumber", null) ||
                          this.validateArrayObject(this.state.sampleRequest.fabric, "fabricId", null))
                      ) {
                        if (data == "save") {
                          this.createFabric(element)
                        } else {
                          this.completeFabric(element)
                        }
                      } else {
                        this.props.getalertMessage("error", "Please fill all mandatory fields")
                      }
                    }
                  
                    validateArrayObject(data, key, val) {
                      let values =
                        data.filter(function (x) {
                          return x[key] == val
                        }).length === 0
                          ? true
                          : false
                      return values
                    } 




                    createFabric = e => {
                        e.preventDefault();
                        let fabric = {};
                        fabric.fabric = this.state.sampleRequest.fabric;
                        fabric._id = this.state._id;
                        fabric.fabricComments = this.state.sampleRequest.fabricComments;
                        fabric.fabricProcess = this.state.sampleRequest.processUpdates.fabric;
                        var count = fabric.fabric.reduce(function (n, data) {
                          return n + (data.fabricPosition !== null);
                        }, 0);
                    
                        if (count == fabric.fabric.length) {
                          SampleServices.createFabric(fabric)
                            .then(response => {
                              if (response.status === 200) {
                                // let sampleRequest = { ...this.state.sampleRequest }
                                // sampleRequest.fabric = response.text.data
                                // this.setState({
                                //   sampleRequest
                                // })
                                this.props.getalertMessage("success", response.text.message);
                              } else if (response.status == 401) {
                                this.props.unauthorisedFunc();
                              } else {
                                this.props.getalertMessage("error", response.text.message);
                              }
                            })
                            .catch(error => this.props.getalertMessage("error", error.toString()));
                        } else {
                          this.props.getalertMessage("error", "fabric position mandatory");
                        }
                      };



                      completeFabric = e => {
                          // e.preventDefault();
                          let sampleRequest = { ...this.state.sampleRequest };
                          let request = {
                            _id: this.state._id,
                            comments: sampleRequest.processUpdates.fabric.comments
                          };
                          SampleServices.completeFabric(request)
                            .then(response => {
                              if (response.status == 200) {
                                sampleRequest.processUpdates.fabric = response.text.data;
                                this.setState({
                                  sampleRequest
                                });
                                this.props.getalertMessage("success", response.text.message);
                              } else if (response.status == 401) {
                                this.props.unauthorisedFunc();
                              } else {
                                this.props.getalertMessage("error", response.text.message);
                              }
                            })
                            .catch(error => this.props.getalertMessage("error", error.toString()));
                        };



                        updateTrimRow1 = (name, value, index) => {
                          let sampleRequest = { ...this.state.sampleRequest };
                          if (name === "trimCategory") {
                            sampleRequest.trim.row1[index][name] = value;
                            sampleRequest.trim.row1[index]["trimNumber"] = null;
                            this.setState({
                              sampleRequest
                            });
                          } else {
                            sampleRequest.trim.row1[index][name] = value;
                            this.setState({
                              sampleRequest
                            });
                          }
                      
                        };



                        getTrimRefNo = (trimCategory, value, index) => {
                            SampleServices.getTrimNumber(trimCategory, value)
                              .then(async response => {
                                const sampleRequest = { ...this.state.sampleRequest };
                                sampleRequest.trim.row1[index].trimList = response.text.data;
                                this.setState({
                                  // trimNumberList: response.text.data
                                  sampleRequest
                                });
                              })
                              .catch(error => alert(error.toString()));
                          };




                          getTrimInfo = (trim, index) => {
                            let sampleRequest = { ...this.state.sampleRequest };
                            if (trim !== null) {
                              sampleRequest.trim.row1[index].trimNumber = trim._id;
                              sampleRequest.trim.row1[index].description = trim.description;
                              sampleRequest.trim.row1[index].quality = trim.quality;
                              sampleRequest.trim.row1[index].sizeNumber = trim.sizeNumber;
                              sampleRequest.trim.row1[index].size = trim.size;
                            } else {
                              sampleRequest.trim.row1[index].trimNumber = null;
                            }
                            this.setState({
                              sampleRequest
                            });
                            // this.samplePrintTrim();
                          };



                          updateTrim = (name, value) => {
                            let sampleRequest = { ...this.state.sampleRequest };
                            sampleRequest.trim[name] = value;
                            this.setState({
                              sampleRequest
                            });
                          };


                          removeTrim = (keyName, index) => {
                            let sampleRequest = { ...this.state.sampleRequest };
                            sampleRequest.trim[keyName].splice(index, 1);
                            this.setState({
                              sampleRequest
                            });
                          };


                          addTrim = keyName => {
                              let sampleRequest = { ...this.state.sampleRequest };
                              let prefillInfo = this.state.prefillInfo;
                              let trimCategory =
                                prefillInfo.TRIM.TRIMCATEGORY &&
                                prefillInfo.TRIM.TRIMCATEGORY.find(
                                  x => x.label.toLowerCase() === "thread"
                                ).value;
                          
                              SampleServices.getTrimNumber(trimCategory, "th-00001")
                                .then(async response => {
                                  let rowdata = {
                                    trimId: response.text.data[0]._id,
                                    trimCategory: trimCategory,
                                    trimNumber: response.text.data[0]._id,
                                    description: response.text.data[0].description,
                                    size: response.text.data[0].size,
                                    quality: response.text.data[0].quality,
                                    sizeNumber: response.text.data[0].sizeNumber,
                                    trimRadio: "notInHse",
                                    trimList: response.text.data
                                  };
                          
                                  if (!sampleRequest.trim[keyName]) {
                                    sampleRequest.trim = {
                                      [keyName]: [rowdata]
                                    };
                                  } else {
                                    sampleRequest.trim[keyName] = [
                                      ...sampleRequest.trim[keyName],
                                      rowdata
                                    ];
                                  }
                          
                                  this.setState({
                                    sampleRequest
                                  });
                                })
                                .catch(error => this.props.getalertMessage("error", error.toString()));
                            };



                            checkValidationTrim = (data, element) => {
                              // console.log(this.validateArrayObject(this.props.fabric , 'fabricPosition', null), "fabricPosition")
                              // console.log(this.validateArrayObject(this.props.fabric , 'fabricNumber', null ), "fabricNumber")
                          
                              if (
                                this.validateArrayObjectTrim(this.state.sampleRequest.trim.row1, "trimNumber", null) &&
                                (this.validateArrayObjectTrim(this.state.sampleRequest.trim.row1, "trimCategory", "") ||
                                  this.validateArrayObjectTrim(this.state.sampleRequest.trim.row1, "trimCategory", null))
                              ) {
                                if (data === "save") {
                                  this.createTrim(element)
                                } else {
                                  this.completeTrim(element)
                                }
                              } else {
                                this.props.getalertMessage("error", "Please fill all mandatory fields")
                              }
                            }
                            validateArrayObjectTrim(data, key, val) {
                              let values =
                                data.filter(function (x) {
                                  return x[key] == val
                                }).length === 0
                                  ? true
                                  : false
                              return values
                            }


                             createTrim = e => {
                                e.preventDefault();
                                let trim = {};
                                trim.trim = this.state.sampleRequest.trim;
                                trim.trimProcess = this.state.sampleRequest.processUpdates.trim;
                                trim._id = this.state._id;
                                SampleServices.createTrim(trim)
                                  .then(response => {
                                    if (response.status === 200) {
                                      let sampleRequest = { ...this.state.sampleRequest };
                                      let row1 = sampleRequest.trim.row1,
                                        row2 = sampleRequest.trim.row2;
                                      sampleRequest.trim = response.text.data;
                                      sampleRequest.trim.row1 = row1;
                                      sampleRequest.trim.row2 = row2;
                                      this.setState({
                                        sampleRequest
                                      });
                                      this.props.getalertMessage("success", response.text.message);
                                    } else if (response.status == 401) {
                                      this.props.unauthorisedFunc();
                                    } else {
                                      this.props.getalertMessage("error", response.text.message);
                                    }
                                  })
                                  .catch(error => this.props.getalertMessage("error", error.toString()));
                              };


                              completeTrim = e => {
                                  // e.preventDefault();
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  let request = {
                                    _id: this.state._id,
                                    comments: sampleRequest.processUpdates.trim.comments
                                  };
                                  SampleServices.completeTrim(request)
                                    .then(response => {
                                      if (response.status === 200) {
                                        sampleRequest.processUpdates.trim = response.text.data;
                                        this.setState({
                                          sampleRequest
                                        });
                                        this.props.getalertMessage("success", response.text.message);
                                      } else if (response.status == 401) {
                                        this.props.unauthorisedFunc();
                                      } else {
                                        this.props.getalertMessage("error", response.text.message);
                                      }
                                    })
                                    .catch(error => this.props.getalertMessage("error", error.toString()));
                                };




                                updatePattern = (name, value) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.pattern[name] = value;
                                  this.setState({
                                    sampleRequest
                                  });
                                };



                                addPatternLog = () => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.pattern.logs.push({
                                    remarks: "",
                                    timeIn: "",
                                    timeOut: "",
                                    breakTime: "",
                                    reason: ""
                                  });
                              
                                  this.setState({
                                    sampleRequest
                                  });
                                };
                              
                                removePatternLog = i => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.pattern.logs.splice(i, 1);
                                  this.setState({
                                    sampleRequest
                                  });
                                };






                                getAssignToList = value => {
                                    PermissionServices.searchEmploye(value).then(async res => {
                                      if (res.status == 200) {
                                        this.setState({ assignedToList: await res.text.data });
                                      }
                                    });
                                  };








                                // common for pattern,sewing,cutting

                              updatePatternCheck = (name, i) => {
                                let sampleRequest = { ...this.state.sampleRequest };
                                sampleRequest.pattern.logs[i][name] = new Date();
                                this.setState({
                                  sampleRequest
                                });
                              };

                              updatePatternLog = (name, value, i) => {
                                let sampleRequest = { ...this.state.sampleRequest };
                                if (name == "timeIn" || name == "timeOut") {
                                  sampleRequest.pattern.logs[i][name] = new Date();
                                } else {
                                  sampleRequest.pattern.logs[i][name] = value;
                                }
                                this.setState({
                                  sampleRequest
                                });
                              };



                              createPattern = e => {
                                  e.preventDefault();
                                  let pattern = {};
                                  pattern.pattern = { ...this.state.sampleRequest.pattern };
                                  pattern.patternProcess = {
                                    ...this.state.sampleRequest.processUpdates.pattern
                                  };
                                  pattern._id = this.state._id;
                                  const { sample } = this.state.sampleRequest.toggle;
                                  const { status } = this.state.sampleRequest.processUpdates.sample;
                              
                                  if (sample && status !== "COMPLETED" && this.state.sampleRequest.processUpdates.pattern.status === "COMPLETED") {
                                    return this.props.getalertMessage("error", "Sample process need to complete!", 5000);
                                  }
                                  SampleServices.createPattern(pattern)
                                    .then(response => {
                                      if (response.status === 200) {
                                        let sampleRequest = { ...this.state.sampleRequest };
                                        sampleRequest.pattern = response.text.data;
                                        this.setState({
                                          sampleRequest
                                        });
                                        this.props.getalertMessage("success", response.text.message);
                                      } else if (response.status == 401) {
                                        this.props.unauthorisedFunc();
                                      } else {
                                        this.props.getalertMessage("error", response.text.message);
                                      }
                                    })
                                    .catch(error => this.props.getalertMessage("error", error.toString()));
                                };
                              
                                completePattern = e => {
                                  // e.preventDefault();
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  let request = {
                                    _id: this.state._id,
                                    comments: sampleRequest.processUpdates.pattern.comments
                                  };
                                  const { sample } = sampleRequest.toggle;
                                  const { status } = sampleRequest.processUpdates.sample;
                              
                                  if (sample && status !== "COMPLETED") {
                                    return this.props.getalertMessage("error", "Sample process need to complete!", 5000);
                                  }
                                  SampleServices.completePattern(request)
                                    .then(response => {
                                      if (response.status === 200) {
                                        sampleRequest.processUpdates.pattern = response.text.data;
                                        this.setState({
                                          sampleRequest
                                        });
                                        this.props.getalertMessage("success", response.text.message);
                                      } else if (response.status == 401) {
                                        this.props.unauthorisedFunc();
                                      } else {
                                        this.props.getalertMessage("error", response.text.message);
                                      }
                                    })
                                    .catch(error => this.props.getalertMessage("error", error.toString()));
                                };






                                updateCutting = (name, value) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  if (name === "cuttingMasterName") {
                                    if (value !== null) {
                                      sampleRequest.cutting[name] = value.value;
                                    } else {
                                      sampleRequest.cutting[name] = null;
                                    }
                                  } else {
                                    sampleRequest.cutting[name] = value;
                                  }
                                  this.setState({
                                    sampleRequest
                                  });
                                };


                                addCuttingLog = () => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.cutting.logs.push({
                                    remarks: "",
                                    timeIn: "",
                                    timeOut: "",
                                    breakTime: "",
                                    reason: ""
                                  });
                              
                                  this.setState({
                                    sampleRequest
                                  });
                                };
                              
                                removeCuttingLog = i => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.cutting.logs.splice(i, 1);
                                  this.setState({
                                    sampleRequest
                                  });
                                };


                                updateCuttingLog = (name, value, i) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  if (name == "timeIn" || name == "timeOut") {
                                    sampleRequest.cutting.logs[i][name] = new Date();
                                  } else {
                                    sampleRequest.cutting.logs[i][name] = value;
                                  }
                                  this.setState({
                                    sampleRequest
                                  });
                                };
                              
                                updateCuttingCheck = (name, i) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.cutting.logs[i][name] = new Date();
                                  this.setState({
                                    sampleRequest
                                  });
                                };


                                createCutting = e => {
                                  let data = {};
                                  data.cutting = this.state.sampleRequest.cutting;
                                  data.cuttingProcess = {
                                    ...this.state.sampleRequest.processUpdates.cutting
                                  };
                                  data._id = this.state._id;
                                  const { pattern, fabric } = this.state.sampleRequest.toggle;
                                  const patternStatus = this.state.sampleRequest.processUpdates.pattern.status;
                                  const fabricStatus = this.state.sampleRequest.processUpdates.fabric.status;
                              
                                  if (this.state.sampleRequest.processUpdates.cutting.status === "COMPLETED" && ((pattern && patternStatus !== "COMPLETED") || (fabric && fabricStatus !== "COMPLETED"))) {
                                    return this.props.getalertMessage("error", "Pattern and Fabric should complete!", 5000);
                                  }
                                  SampleServices.createCutting(data)
                                    .then(response => {
                                      if (response.status === 200) {
                                        let sampleRequest = { ...this.state.sampleRequest };
                                        sampleRequest.cutting = response.text.data;
                                        this.setState({
                                          sampleRequest
                                        });
                                        this.props.getalertMessage("success", response.text.message);
                                      } else if (response.status == 401) {
                                        this.props.unauthorisedFunc();
                                      } else {
                                        this.props.getalertMessage("error", response.text.message);
                                      }
                                    })
                                    .catch(error => this.props.getalertMessage("error", error.toString()));
                                };
                              
                                completeCutting = e => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  let request = {
                                    _id: this.state._id,
                                    comments: sampleRequest.processUpdates.cutting.comments
                                  };
                                  const { pattern, fabric } = this.state.sampleRequest.toggle;
                                  const patternStatus = this.state.sampleRequest.processUpdates.pattern.status;
                                  const fabricStatus = this.state.sampleRequest.processUpdates.fabric.status;
                              
                                  if ((pattern && patternStatus !== "COMPLETED") || (fabric && fabricStatus !== "COMPLETED")) {
                                    return this.props.getalertMessage("error", "Pattern and Fabric should complete!", 5000);
                                  }
                                  SampleServices.completeCutting(request)
                                    .then(response => {
                                      if (response.status === 200) {
                                        sampleRequest.processUpdates.cutting = response.text.data;
                                        this.setState({
                                          sampleRequest
                                        });
                                        this.props.getalertMessage("success", response.text.message);
                                      } else if (response.status == 401) {
                                        this.props.unauthorisedFunc();
                                      } else {
                                        this.props.getalertMessage("error", response.text.message);
                                      }
                                    })
                                    .catch(error => this.props.getalertMessage("error", error.toString()));
                                };



                                updateSewing1 = (name, value) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  if (name === "smokingOrShiring") {
                                    sampleRequest.sewing.smokingOrShiring = !sampleRequest.sewing
                                      .smokingOrShiring;
                                  } else {
                                    sampleRequest.sewing[name] = value;
                                  }
                                  this.setState(
                                    {
                                      sampleRequest
                                    },
                                     () => this.onSmockingShirring()
                                  );
                                };


                                onSmockingShirring = () => {
                                    let sampleRequest = { ...this.state.sampleRequest };
                                    if (
                                      sampleRequest.sewing &&
                                      sampleRequest.sewing.trimData &&
                                      sampleRequest.sewing.trimData.length > 0
                                    ) {
                                      sampleRequest.sewing.trimData.forEach((x, i) => {
                                        if (x.trimCategory) {
                                          SampleServices.getTrimNumber(x.trimCategory)
                                            .then(async response => {
                                              sampleRequest.sewing.trimData[i].trimList = response.text.data;
                                            })
                                            .catch(error => alert(error.toString()));
                                        }
                                      });
                                    } else {
                                      sampleRequest.sewing.trimData = [];
                                      if (sampleRequest.sewing.trimData.length === 0) {
                                        let prefillInfo = { ...this.state.prefillInfo.TRIM };
                                        let trimCategory =
                                          prefillInfo.TRIMCATEGORY &&
                                          prefillInfo.TRIMCATEGORY.filter(
                                            x => x.label.toLowerCase() === "thread"
                                          )[0].value;
                                        SampleServices.getTrimNumber(trimCategory, "")
                                          .then(async response => {
                                            // let sampleRequest = { ...this.state.sampleRequest };
                                            sampleRequest.sewing.trimData[0] = {
                                              trimId: null,
                                              trimCategory: trimCategory,
                                              trimNumber: "",
                                              description: "",
                                              size: "",
                                              quality: "",
                                              sizeNumber: "",
                                              trimRadio: "notInHse"
                                            };
                                            sampleRequest.sewing.trimData[0].trimList = response.text.data;
                                            this.setState({
                                              sampleRequest
                                            });
                                          })
                                          .catch(error =>
                                            this.props.getalertMessage("error", error.toString())
                                          );
                                      }
                                    }
                                
                                    this.setState({
                                      sampleRequest
                                    });
                                  };


                                addSewing = () => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.sewing.sewingData.push({
                                    tailorName: null,
                                    sewingType: null,
                                    size: "",
                                    quantity: "",
                                    approvalStatus: "",
                                    rejected: "",
                                    logs: [
                                      // {
                                      //   remarks: "",
                                      //   timeIn: "",
                                      //   timeOut: "",
                                      //   breakTime: "",
                                      //   reason: ""
                                      // }
                                    ]
                                  });
                                  this.setState({
                                    sampleRequest
                                  });
                                };
                              
                                removeSewing = index => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  // sampleRequest.sewing.sewingData = sampleRequest.sewing.sewingData.filter((d,i) => i != index)
                                  sampleRequest.sewing.sewingData.splice(index, 1);
                                  this.setState({
                                    sampleRequest
                                  });
                                };



                                updateSewing = (name, value, index) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  if (name === "tailorName") {
                                    if (value !== null) {
                                      sampleRequest.sewing.sewingData[index][name] = value.value;
                                    } else {
                                      sampleRequest.sewing.sewingData[index][name] = null;
                                    }
                                  } else {
                                    sampleRequest.sewing.sewingData[index][name] = value;
                                  }
                                  this.setState({
                                    sampleRequest
                                  });
                                };

                                


                                updateSewingLog = (name, value, i, index) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  if (name == "timeIn" || name == "timeOut") {
                                    sampleRequest.sewing.sewingData[index].logs[i][name] = new Date();
                                  } else {
                                    sampleRequest.sewing.sewingData[index].logs[i][name] = value;
                                  }
                                  this.setState({
                                    sampleRequest
                                  });
                                };

                                updateSewingCheck = (name, i, index) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.sewing.sewingData[index].logs[i][name] = new Date();
                                  this.setState({
                                    sampleRequest
                                  });
                                };



                                addSewingLog = index => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.sewing.sewingData[index].logs.push({
                                    remarks: "",
                                    timeIn: "",
                                    timeOut: "",
                                    breakTime: "",
                                    reason: ""
                                  });
                              
                                  this.setState({
                                    sampleRequest
                                  });
                                };
                              
                                removeSewingLog = (i, index) => {
                                  let sampleRequest = { ...this.state.sampleRequest };
                                  sampleRequest.sewing.sewingData[index].logs.splice(i, 1);
                                  this.setState({
                                    sampleRequest
                                  });
                                };


                                updateSewingTrimData = (name, value, index) => {
                                    let sampleRequest = { ...this.state.sampleRequest };
                                    sampleRequest.sewing.trimData[index][name] = value;
                                    this.setState(
                                      {
                                        sampleRequest
                                      },
                                      () => this.updateCalcSewing()
                                    );
                                    if (name == "trimCategory") {
                                      SampleServices.getTrimNumber(value, "")
                                        .then(async response => {
                                          let sampleRequest = { ...this.state.sampleRequest };
                                          sampleRequest.sewing.trimData[index].trimList = response.text.data;
                                          this.setState({
                                            sampleRequest
                                          });
                                        })
                                        .catch(error => this.props.getalertMessage("error", error.toString()));
                                    }
                                  };


                                  updateCalcSewing = () => {
                                    let sampleRequest = { ...this.state.sampleRequest };
                                    const {
                                      smockingorElastic,
                                      toptthElastic
                                    } = this.state.prefillInfo.SAMPLEREQUEST.SHIRRINGORSMOCKING;
                                    sampleRequest.sewing.trimData = sampleRequest.sewing.trimData.map(
                                      (data, index) => {
                                        if (data.type == "Both Elastic") {
                                          data.multiple = Number(smockingorElastic.multiple);
                                          data.wastage = Number(smockingorElastic.wastage);
                                        }
                                        if (data.type == "Top TTH / Bottom Elastic") {
                                          data.multiple = Number(toptthElastic.multiple);
                                          data.wastage = Number(toptthElastic.wastage);
                                        }
                                        if (
                                          data.multiple !== null &&
                                          data.noOfRow !== null &&
                                          data.length !== null
                                        ) {
                                          let calc =
                                            Number(parseFloat(data.noOfRow)) *
                                            Number(parseFloat(data.length)) *
                                            Number(parseFloat(data.multiple));
                                          // /100
                                          data.totalReq = Number(
                                            (calc + calc * (data.wastage / 100)).toFixed(2)
                                          );
                                        }
                                        return data;
                                      }
                                    );
                                    this.setState({
                                      sampleRequest
                                    });
                                  };


                                  getTrimRefNoSewing = (trimCategory, value, index) => {
                                      SampleServices.getTrimNumber(trimCategory, value)
                                        .then(async response => {
                                          const sampleRequest = { ...this.state.sampleRequest };
                                  
                                          sampleRequest.sewing.trimData[index].trimList = response.text.data;
                                          this.setState({
                                            // trimNumberList: response.text.data
                                            sampleRequest
                                          });
                                        })
                                        .catch(error => alert(error.toString()));
                                    };



                                    getTrimInfoSewTrimData = (trim, index) => {
                                      let sampleRequest = { ...this.state.sampleRequest };
                                      if (trim !== null) {
                                        sampleRequest.sewing.trimData[index].trimNumber = trim._id;
                                        sampleRequest.sewing.trimData[index].description = trim.description;
                                        sampleRequest.sewing.trimData[index].quality = trim.quality;
                                        sampleRequest.sewing.trimData[index].sizeNumber = trim.sizeNumber;
                                        sampleRequest.sewing.trimData[index].size = trim.size;
                                      } else {
                                        sampleRequest.sewing.trimData[index].trimNumber = null;
                                      }
                                      this.setState({
                                        sampleRequest
                                      });
                                    };




                                    smockingShirringaddTrim = () => {
                                        let sampleRequest = { ...this.state.sampleRequest };
                                        let prefillInfo = { ...this.state.prefillInfo.TRIM };
                                        let trimCategory =
                                          prefillInfo.TRIMCATEGORY &&
                                          prefillInfo.TRIMCATEGORY.filter(
                                            x => x.label.toLowerCase() === "thread"
                                          )[0].value;
                                        SampleServices.getTrimNumber(trimCategory, "")
                                          .then(async response => {
                                            // let sampleRequest = { ...this.state.sampleRequest };
                                            sampleRequest.sewing.trimData.push({
                                              trimId: null,
                                              trimCategory: trimCategory,
                                              trimNumber: "",
                                              description: "",
                                              size: "",
                                              quality: "",
                                              sizeNumber: "",
                                              trimRadio: "notInHse"
                                            });
                                    
                                            sampleRequest.sewing.trimData[
                                              sampleRequest.sewing.trimData.length - 1
                                            ].trimList = response.text.data;
                                            this.setState({
                                              sampleRequest
                                            });
                                          })
                                          .catch(error => this.props.getalertMessage("error", error.toString()));
                                      };
                                    
                                      smockingShirringremoveTrim = index => {
                                        let sampleRequest = { ...this.state.sampleRequest };
                                    
                                        sampleRequest.sewing.trimData.splice(index, 1);
                                        this.setState({
                                          sampleRequest
                                        });
                                      };



                                      createSewing = e => {
                                          e.preventDefault();
                                          let data = {};
                                          let sewing = { ...this.state.sampleRequest.sewing };
                                          if (!sewing.smokingOrShiring) {
                                            sewing.trimData = [];
                                          }
                                          data.sewing = sewing;
                                      
                                          data.sewingProcess = this.state.sampleRequest.processUpdates.sewing;
                                          data._id = this.state._id;
                                          const { cutting } = this.state.sampleRequest.toggle;
                                          const { status } = this.state.sampleRequest.processUpdates.cutting;
                                      
                                          if (this.state.sampleRequest.processUpdates.sewing.status === "COMPLETED" && cutting && status !== "COMPLETED") {
                                            return this.props.getalertMessage("error", "Cutting process need to complete!", 5000);
                                          }
                                          SampleServices.createSewing(data)
                                            .then(response => {
                                              if (response.status === 200) {
                                                let sampleRequest = { ...this.state.sampleRequest };
                                      
                                                const sewingData = sampleRequest.sewing.sewingData;
                                                const trimData = sampleRequest.sewing.trimData;
                                                sampleRequest.sewing = response.text.data;
                                                sampleRequest.sewing.sewingData = sewingData;
                                                sampleRequest.sewing.trimData = trimData;
                                      
                                                this.setState({
                                                  sampleRequest
                                                });
                                                this.props.getalertMessage("success", response.text.message);
                                              } else if (response.status == 401) {
                                                this.props.unauthorisedFunc();
                                              } else {
                                                this.props.getalertMessage("error", response.text.message);
                                              }
                                            })
                                            .catch(error => this.props.getalertMessage("error", error.toString()));
                                        };
                                      
                                        completeSewing = e => {
                                          let sampleRequest = { ...this.state.sampleRequest };
                                          let request = {
                                            _id: this.state._id,
                                            comments: sampleRequest.processUpdates.sewing.comments
                                          };
                                          const { cutting } = sampleRequest.toggle;
                                          const { status } = sampleRequest.processUpdates.cutting;
                                      
                                          if (cutting && status !== "COMPLETED") {
                                            return this.props.getalertMessage("error", "Cutting process need to complete!", 5000);
                                          }
                                          SampleServices.completeSewing(request)
                                            .then(response => {
                                              if (response.status === 200) {
                                                sampleRequest.processUpdates.sewing = response.text.data;
                                                this.setState({
                                                  sampleRequest
                                                });
                                                this.props.getalertMessage("success", response.text.message);
                                              } else if (response.status == 401) {
                                                this.props.unauthorisedFunc();
                                              } else {
                                                this.props.getalertMessage("error", response.text.message);
                                              }
                                            })
                                            .catch(error => this.props.getalertMessage("error", error.toString()));
                                        };




                                        updateMarker = (name, value) => {
                                          let sampleRequest = { ...this.state.sampleRequest };
                                          sampleRequest.marker[name] = value;
                                          this.setState([sampleRequest]);
                                        };




                                        createMarker = e => {
                                            e.preventDefault();
                                            let objData = {};
                                            objData.marker = this.state.sampleRequest.marker;
                                            objData.markerProcess = this.state.sampleRequest.processUpdates.marker;
                                            objData._id = this.state._id;
                                            SampleServices.createMarker(objData)
                                              .then(response => {
                                                if (response.status === 200) {
                                                  let sampleRequest = { ...this.state.sampleRequest };
                                                  sampleRequest.marker = response.text.data;
                                                  this.setState({
                                                    sampleRequest
                                                  });
                                                  this.props.getalertMessage("success", response.text.message);
                                                } else if (response.status == 401) {
                                                  this.props.unauthorisedFunc();
                                                } else {
                                                  this.props.getalertMessage("error", response.text.message);
                                                }
                                              })
                                              .catch(error => this.props.getalertMessage("error", error.toString()));
                                          };
                                        
                                          completeMarker = e => {
                                            let sampleRequest = { ...this.state.sampleRequest };
                                            let request = {
                                              _id: this.state._id,
                                              comments: sampleRequest.processUpdates.marker.comments
                                            };
                                            SampleServices.completeMarker(request)
                                              .then(response => {
                                                if (response.status === 200) {
                                                  sampleRequest.processUpdates.marker = response.text.data;
                                                  this.setState({
                                                    sampleRequest
                                                  });
                                                  this.props.getalertMessage("success", response.text.message);
                                                } else if (response.status == 401) {
                                                  this.props.unauthorisedFunc();
                                                } else {
                                                  this.props.getalertMessage("error", response.text.message);
                                                }
                                              })
                                              .catch(error => this.props.getalertMessage("error", error.toString()));
                                          };



                                          addEmb = () => {
                                            let sampleRequest = { ...this.state.sampleRequest };
                                            sampleRequest.embellishment.push({
                                              embType: null,
                                              hoursMinutes: null,
                                              pricePerHalfHour: null
                                            });
                                            this.setState({
                                              sampleRequest
                                            });
                                          };
                                        
                                          removeEmb = index => {
                                            let sampleRequest = { ...this.state.sampleRequest };
                                            sampleRequest.embellishment.splice(index, 1);
                                            this.setState({
                                              sampleRequest
                                            });
                                          };



                                          updateEmbellishment = (name, value, index) => {
                                            let sampleRequest = { ...this.state.sampleRequest };
                                            sampleRequest.embellishment[index][name] = value;
                                            this.setState({
                                              sampleRequest
                                            });
                                          };



                                          createEmbellishment = e => {
                                              let info = {};
                                              info.embellishment = this.state.sampleRequest.embellishment;
                                              info.embellishmentProcess = this.state.sampleRequest.processUpdates.embellishment;
                                              info.embellishmentComments = this.state.sampleRequest.embellishmentComments
                                              info._id = this.state._id;
                                              SampleServices.createEmbelishment(info)
                                                .then(response => {
                                                  if (response.status === 200) {
                                                    let sampleRequest = { ...this.state.sampleRequest };
                                                    sampleRequest.embellishment = response.text.data;
                                                    this.setState({
                                                      sampleRequest
                                                    });
                                                    this.props.getalertMessage("success", response.text.message);
                                                  } else if (response.status == 401) {
                                                    this.props.unauthorisedFunc();
                                                  } else {
                                                    this.props.getalertMessage("error", response.text.message);
                                                  }
                                                })
                                                .catch(error => this.props.getalertMessage("error", error.toString()));
                                            };
                                          
                                            completeEmbellishment = () => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              let request = {
                                                _id: this.state._id,
                                                comments: sampleRequest.processUpdates.embellishment.comments
                                              };
                                              SampleServices.completeEmbelishment(request)
                                                .then(response => {
                                                  if (response.status === 200) {
                                                    sampleRequest.processUpdates.embellishment = response.text.data;
                                                    this.setState({
                                                      sampleRequest
                                                    });
                                                    this.props.getalertMessage("success", response.text.message);
                                                  } else if (response.status == 401) {
                                                    this.props.unauthorisedFunc();
                                                  } else {
                                                    this.props.getalertMessage("error", response.text.message);
                                                  }
                                                })
                                                .catch(error => this.props.getalertMessage("error", error.toString()));
                                            };




                                            updateEmbroidery = (name, value) => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery[name] = value;
                                              this.setState({
                                                sampleRequest
                                              });
                                            };



                                            moveToRight = () => {
                                              var x = document.getElementById("mySelect").selectedIndex;
                                              // var y = document.getElementById("mySelect").options;
                                              // // alert("Index: " + y[x].index + " is " + y[x].text);
                                              // var z = document.getElementById("mySelect2");
                                              // var option = document.createElement("option");
                                              // option.text = document.getElementById("mySelect").value;
                                              // z.add(option);
                                          
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.rightData.push(
                                                document.getElementById("mySelect").value
                                              );
                                              sampleRequest.embroidery.leftData.splice(
                                                document.getElementById("mySelect").selectedIndex,
                                                1
                                              );
                                          
                                              this.setState({ sampleRequest });
                                              // document.getElementById("mySelect").remove(y[x].index);
                                            };
                                          
                                            moveToLeft = () => {
                                              var x = document.getElementById("mySelect2").selectedIndex;
                                              // var y = document.getElementById("mySelect2").options;
                                              // // alert("Index: " + y[x].index + " is " + y[x].text);
                                              // var z = document.getElementById("mySelect");
                                              // var option = document.createElement("option");
                                              // option.text = document.getElementById("mySelect2").value;
                                              // z.add(option);
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.leftData.push(
                                                document.getElementById("mySelect2").value
                                              );
                                              sampleRequest.embroidery.rightData.splice(
                                                document.getElementById("mySelect2").selectedIndex,
                                                1
                                              );
                                          
                                              this.setState({ sampleRequest });
                                          
                                              // document.getElementById("mySelect2").remove(y[x].index);
                                            };
                                          
                                            moveToUp = () => {
                                              var x = document.getElementById("mySelect2").selectedIndex;
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.rightData = this.swapIndices(
                                                sampleRequest.embroidery.rightData,
                                                x,
                                                x - 1
                                              );
                                              this.setState({ sampleRequest });
                                            };
                                            moveToBottom = () => {
                                              var x = document.getElementById("mySelect2").selectedIndex;
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.rightData = this.swapIndices(
                                                sampleRequest.embroidery.rightData,
                                                x,
                                                x + 1
                                              );
                                              this.setState({ sampleRequest });
                                            };


                                            swapIndices = (array, index1, index2) => {
                                              const newArray = array.slice();
                                              newArray[index1] = array[index2];
                                              newArray[index2] = array[index1];
                                              return newArray;
                                            };



                                            changeBackingArray = (action, index) => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              action === "add"
                                                ? sampleRequest.embroidery.backingData.push({
                                                  backingType: null,
                                                  width: null,
                                                  placement: null
                                                })
                                                : sampleRequest.embroidery.backingData.splice(index, 1);
                                              this.setState({ sampleRequest });
                                            };



                                            updateEmbroideryBackingData = (name, value, i) => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.backingData[i][name] = value;
                                              this.setState({
                                                sampleRequest
                                              });
                                          
                                              if (name == "backingType") {
                                                this.state.prefillInfo.SYSTEMSAMPLEREQUEST.BACKINGTYPE.map(
                                                  (data, index) => {
                                                    if (data.value == value) {
                                                      let widthList = [];
                                                      data.typeMultiple.map(dat1 => {
                                                        widthList.push({
                                                          label: dat1.width,
                                                          value: dat1.width
                                                        });
                                                      });
                                                      this.setState({
                                                        widthList
                                                      });
                                                    }
                                                  }
                                                );
                                              }
                                            };




                                            addEmbroideryData = () => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.embroideryData.push({
                                                embPlacement: null,
                                                embForm: null,
                                                noOfCols: null,
                                                frames: null,
                                                stitchesMtr: "",
                                                consumption: "",
                                                stitchCount: "",
                                                priceForStitches: ""
                                              });
                                              this.setState({
                                                sampleRequest
                                              });
                                            };
                                          
                                            removeEmbroideryData = i => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                              sampleRequest.embroidery.embroideryData = sampleRequest.embroidery.embroideryData.filter(
                                                (d, ind) => ind != i
                                              );
                                              this.setState({
                                                sampleRequest
                                              });
                                            };




                                            updateEmbroideryData = (name, value, i) => {
                                              let sampleRequest = { ...this.state.sampleRequest };
                                          
                                              sampleRequest.embroidery.embroideryData[i][name] = value;
                                              if (name === "consumption" || name === "stitchesMtr") {
                                                let consumption = sampleRequest.embroidery.embroideryData[i].consumption
                                                  ? sampleRequest.embroidery.embroideryData[i].consumption
                                                  : 0;
                                                let stitches = sampleRequest.embroidery.embroideryData[i].stitchesMtr
                                                  ? sampleRequest.embroidery.embroideryData[i].stitchesMtr
                                                  : 0;
                                                let stitchCount = consumption * stitches;
                                                sampleRequest.embroidery.embroideryData[i].stitchCount = Number(
                                                  stitchCount
                                                ).toFixed(2);
                                              }
                                              if (name === "embForm") {
                                                sampleRequest.embroidery.embroideryData[i][name] = value;
                                                sampleRequest.embroidery.embroideryData[
                                                  i
                                                ].priceForStitches = this.state.prefillInfo.SAMPLEREQUEST.EMBFORM.find(
                                                  x => x.label === value
                                                ).price;
                                              } else {
                                                sampleRequest.embroidery.embroideryData[i][name] = value;
                                              }
                                          
                                              this.setState({
                                                sampleRequest
                                              });
                                            };



                                            saveEmbroidery = e => {
                                                e.preventDefault();
                                                let info = {};
                                                info.embroidery = this.state.sampleRequest.embroidery;
                                                info.embroideryProcess = this.state.sampleRequest.processUpdates.embroidery;
                                                info._id = this.state._id;
                                                SampleServices.createEmbroidery(info)
                                                  .then(response => {
                                                    if (response.status === 200) {
                                                      let sampleRequest = { ...this.state.sampleRequest };
                                                      sampleRequest.embroidery = response.text.data;
                                                      this.setState({
                                                        sampleRequest
                                                      });
                                                      this.props.getalertMessage("success", response.text.message);
                                                    } else if (response.status == 401) {
                                                      this.props.unauthorisedFunc();
                                                    } else {
                                                      this.props.getalertMessage("error", response.text.message);
                                                    }
                                                  })
                                                  .catch(error => this.props.getalertMessage("error", error.toString()));
                                              };
                                            
                                              completeEmbroidery = e => {
                                                let sampleRequest = { ...this.state.sampleRequest };
                                                let request = {
                                                  _id: this.state._id,
                                                  comments: sampleRequest.processUpdates.embroidery.comments
                                                };
                                                SampleServices.completeEmbroidery(request)
                                                  .then(response => {
                                                    if (response.status === 200) {
                                                      sampleRequest.processUpdates.embroidery = response.text.data;
                                                      this.setState({
                                                        sampleRequest
                                                      });
                                                      this.props.getalertMessage("success", response.text.message);
                                                    } else if (response.status == 401) {
                                                      this.props.unauthorisedFunc();
                                                    } else {
                                                      this.props.getalertMessage("error", response.text.message);
                                                    }
                                                  })
                                                  .catch(error => this.props.getalertMessage("error", error.toString()));
                                              };





                                              updateDispatch = (name, value) => {
                                                let sampleRequest = { ...this.state.sampleRequest };
                                                sampleRequest.dispatch[name] = value;
                                                this.setState({
                                                  sampleRequest
                                                });
                                              };


                                              addDispatchData = () => {
                                                  let sampleRequest = { ...this.state.sampleRequest };
                                                  sampleRequest.dispatch.data.push({
                                                    location: null,
                                                    date: moment()
                                                      .subtract(1, "day")
                                                      .format(),
                                                    courier: null,
                                                    awbNumber: "",
                                                    size: null,
                                                    quantity: null
                                                  });
                                                  this.setState({
                                                    sampleRequest
                                                  });
                                                };
                                              
                                                removeDispatchData = i => {
                                                  let sampleRequest = { ...this.state.sampleRequest };
                                                  sampleRequest.dispatch.data = sampleRequest.dispatch.data.filter(
                                                    (d, ind) => ind != i
                                                  );
                                                  this.setState({
                                                    sampleRequest
                                                  });
                                                };


                                                udpateDispatchValues = (name, value, i) => {
                                                  let sampleRequest = { ...this.state.sampleRequest };
                                                  sampleRequest.dispatch.data[i][name] = value;
                                                  this.setState({
                                                    sampleRequest
                                                  });
                                                };



                                                createDispatch = e => {
                                                    e.preventDefault();
                                                    let objData = {};
                                                    objData.dispatch = this.state.sampleRequest.dispatch;
                                                    objData.dispatchProcess = this.state.sampleRequest.processUpdates.dispatch;
                                                    objData._id = this.state._id;
                                                    const { sewing, wash } = this.state.sampleRequest.toggle;
                                                    const { status } = this.state.sampleRequest.processUpdates.sewing;
                                                    const washStatus = this.state.sampleRequest.processUpdates.wash.status;
                                                    if (this.state.sampleRequest.processUpdates.dispatch.status === "COMPLETED")
                                                      if (sewing && status !== "COMPLETED") {
                                                        return this.props.getalertMessage("error", "Sewing process need to complete!", 5000);
                                                      } else if (wash && (washStatus === "PENDING" || washStatus === "IN PROCESS")) {
                                                        return this.props.getalertMessage("error", "Washing process need to complete or cancel!", 5000);
                                                      }
                                                    SampleServices.createDispatch(objData)
                                                      .then(response => {
                                                        if (response.status === 200) {
                                                          let sampleRequest = { ...this.state.sampleRequest };
                                                          sampleRequest.wash = response.text.data;
                                                          this.setState({
                                                            sampleRequest
                                                          });
                                                          this.props.getalertMessage("success", response.text.message);
                                                        } else if (response.status == 401) {
                                                          this.props.unauthorisedFunc();
                                                        } else {
                                                          this.props.getalertMessage("error", response.text.message);
                                                        }
                                                      })
                                                      .catch(error => this.props.getalertMessage("error", error.toString()));
                                                  };
                                                
                                                  completeDispatch = e => {
                                                    let sampleRequest = { ...this.state.sampleRequest };
                                                    let request = {
                                                      _id: this.state._id,
                                                      comments: sampleRequest.processUpdates.dispatch.comments
                                                    };
                                                    const { sewing, wash } = sampleRequest.toggle;
                                                    const { status } = sampleRequest.processUpdates.sewing;
                                                    const washStatus = sampleRequest.processUpdates.wash.status;
                                                    if (sewing && status !== "COMPLETED") {
                                                      return this.props.getalertMessage("error", "Sewing process need to complete!", 5000);
                                                    } else if (wash && (washStatus === "PENDING" || washStatus === "IN PROCESS")) {
                                                      return this.props.getalertMessage("error", "Washing process need to complete or cancel!", 5000);
                                                    }
                                                    SampleServices.completeDispatch(request)
                                                      .then(response => {
                                                        if (response.status === 200) {
                                                          sampleRequest.processUpdates.dispatch = response.text.data;
                                                          this.setState({
                                                            sampleRequest
                                                          });
                                                          this.props.getalertMessage("success", response.text.message);
                                                        } else if (response.status == 401) {
                                                          this.props.unauthorisedFunc();
                                                        } else {
                                                          this.props.getalertMessage("error", response.text.message);
                                                        }
                                                      })
                                                      .catch(error => this.props.getalertMessage("error", error.toString()));
                                                  };



                                                  updateQc = (name, value) => {
                                                    let sampleRequest = { ...this.state.sampleRequest };
                                                    sampleRequest.qc[name] = value;
                                                    this.setState({
                                                      sampleRequest
                                                    });
                                                  };



                                                  createQC = e => {
                                                      e.preventDefault();
                                                      let info = {};
                                                      info.qc = this.state.sampleRequest.qc;
                                                      info.qcProcess = this.state.sampleRequest.processUpdates.qc;
                                                      info._id = this.state._id;
                                                      SampleServices.createQC(info)
                                                        .then(response => {
                                                          if (response.status === 200) {
                                                            let sampleRequest = { ...this.state.sampleRequest };
                                                            sampleRequest.qc = response.text.data;
                                                            this.setState({
                                                              sampleRequest
                                                            });
                                                            this.props.getalertMessage("success", response.text.message);
                                                          } else if (response.status == 401) {
                                                            this.props.unauthorisedFunc();
                                                          } else {
                                                            this.props.getalertMessage("error", response.text.message);
                                                          }
                                                        })
                                                        .catch(error => this.props.getalertMessage("error", error.toString()));
                                                    };
                                                  
                                                    completeQC = e => {
                                                      // e.preventDefault();
                                                      let sampleRequest = { ...this.state.sampleRequest };
                                                      let request = {
                                                        _id: this.state._id,
                                                        comments: sampleRequest.processUpdates.qc.comments
                                                      };
                                                      SampleServices.completeQC(request)
                                                        .then(response => {
                                                          if (response.status === 200) {
                                                            sampleRequest.processUpdates.qc = response.text.data;
                                                            this.setState({
                                                              sampleRequest
                                                            });
                                                            this.props.getalertMessage("success", response.text.message);
                                                          } else if (response.status == 401) {
                                                            this.props.unauthorisedFunc();
                                                          } else {
                                                            this.props.getalertMessage("error", response.text.message);
                                                          }
                                                        })
                                                        .catch(error => this.props.getalertMessage("error", error.toString()));
                                                    };



                                                    createSignOff = e => {
                                                        e.preventDefault();
                                                        let objData = {};
                                                        objData.signOffComments = this.state.sampleRequest.signOffComments;
                                                        objData.signOffProcess = this.state.sampleRequest.processUpdates.signOff;
                                                        objData._id = this.state._id;
                                                        SampleServices.createSignOff(objData)
                                                          .then(response => {
                                                            if (response.status === 200) {
                                                              let sampleRequest = { ...this.state.sampleRequest };
                                                              sampleRequest.signOffComments = response.text.data;
                                                              this.setState({
                                                                sampleRequest
                                                              });
                                                              this.props.getalertMessage("success", response.text.message);
                                                            } else if (response.status == 401) {
                                                              this.props.unauthorisedFunc();
                                                            } else {
                                                              this.props.getalertMessage("error", response.text.message);
                                                            }
                                                          })
                                                          .catch(error => this.props.getalertMessage("error", error.toString()));
                                                      };
                                                    
                                                      completeSignoff = e => {
                                                        let sampleRequest = { ...this.state.sampleRequest };
                                                        let request = {
                                                          _id: this.state._id,
                                                          comments: sampleRequest.processUpdates.signOff.comments
                                                        };
                                                        SampleServices.completeSignOff(request)
                                                          .then(response => {
                                                            if (response.status === 200) {
                                                              sampleRequest.processUpdates.signOff = response.text.data;
                                                              this.setState({
                                                                sampleRequest
                                                              });
                                                              this.props.getalertMessage("success", response.text.message);
                                                            } else if (response.status == 401) {
                                                              this.props.unauthorisedFunc();
                                                            } else {
                                                              this.props.getalertMessage("error", response.text.message);
                                                            }
                                                          })
                                                          .catch(error => this.props.getalertMessage("error", error.toString()));
                                                      };



                                                      getRefImages = (refImages, moduleName) => {
                                                        let sampleRequest = { ...this.state.sampleRequest };
                                                        sampleRequest[moduleName].refImages = refImages;
                                                        this.setState({
                                                          sampleRequest
                                                        });
                                                      };



                                                      updateWash1 = (name, value) => {
                                                        let sampleRequest = { ...this.state.sampleRequest };
                                                        if (name === "washType") {
                                                          let washData = this.state.prefillInfo.WASH.WASHTYPE.find(
                                                            x => x.value === value
                                                          );
                                                          sampleRequest.wash.washData.price = washData && washData.price || '';
                                                        }
                                                        sampleRequest.wash.washData[name] = value;
                                                        this.setState({
                                                          sampleRequest
                                                        });
                                                      };


                                                      updateWash = (name, value) => {
                                                        let sampleRequest = { ...this.state.sampleRequest };
                                                        sampleRequest.wash[name] = value;
                                                        this.setState({
                                                          sampleRequest
                                                        });
                                                      };




                                                      createWash = e => {
                                                          e.preventDefault();
                                                          let info = {};
                                                          info.wash = this.state.sampleRequest.wash;
                                                          info.washProcess = this.state.sampleRequest.processUpdates.wash;
                                                          info._id = this.state._id;
                                                          SampleServices.createWash(info)
                                                            .then(response => {
                                                              if (response.status === 200) {
                                                                let sampleRequest = { ...this.state.sampleRequest };
                                                                sampleRequest.wash = response.text.data;
                                                                this.setState({
                                                                  sampleRequest
                                                                });
                                                                this.props.getalertMessage("success", response.text.message);
                                                              } else if (response.status == 401) {
                                                                this.props.unauthorisedFunc();
                                                              } else {
                                                                this.props.getalertMessage("error", response.text.message);
                                                              }
                                                            })
                                                            .catch(error => this.props.getalertMessage("error", error.toString()));
                                                        };
                                                      
                                                        completeWash = e => {
                                                          let sampleRequest = { ...this.state.sampleRequest };
                                                          let request = {
                                                            _id: this.state._id,
                                                            comments: sampleRequest.processUpdates.wash.comments
                                                          };
                                                          SampleServices.completeWash(request)
                                                            .then(response => {
                                                              if (response.status === 200) {
                                                                sampleRequest.processUpdates.wash = response.text.data;
                                                                this.setState({
                                                                  sampleRequest
                                                                });
                                                                this.props.getalertMessage("success", response.text.message);
                                                              } else if (response.status == 401) {
                                                                this.props.unauthorisedFunc();
                                                              } else {
                                                                this.props.getalertMessage("error", response.text.message);
                                                              }
                                                            })
                                                            .catch(error => this.props.getalertMessage("error", error.toString()));
                                                        };


                                                        // logOut() {
                                                        //         localStorage.removeItem("authToken");
                                                        //         localStorage.clear();
                                                        //          //this.props.signOut();
                                                        //         this.props.history !== undefined && this.props.history.push("/login")
                                                        //     }



                                                        updateGarment = (name, value) => {
                                                          let sampleRequest = { ...this.state.sampleRequest };
                                                          sampleRequest.garmentTechnologist[name] = value;
                                                          this.setState([sampleRequest]);
                                                        };



                                                        createGarment = e => {
                                                            e.preventDefault();
                                                            let info = {};
                                                            info.garmentTechnologist = this.state.sampleRequest.garmentTechnologist;
                                                            info.garmentProcess = this.state.sampleRequest.processUpdates.garmentTechnologist;
                                                            info._id = this.state._id;
                                                            SampleServices.createGarment(info)
                                                              .then(response => {
                                                                if (response.status === 200) {
                                                                  let sampleRequest = { ...this.state.sampleRequest };
                                                                  sampleRequest.garmentTechnologist = response.text.data;
                                                                  this.setState({
                                                                    sampleRequest
                                                                  });
                                                                  this.props.getalertMessage("success", response.text.message);
                                                                } else if (response.status == 401) {
                                                                  this.props.unauthorisedFunc();
                                                                } else {
                                                                  this.props.getalertMessage("error", response.text.message);
                                                                }
                                                              })
                                                              .catch(error => this.props.getalertMessage("error", error.toString()));
                                                          };


                                                          completeGarment = e => {
                                                              let sampleRequest = { ...this.state.sampleRequest };
                                                              let request = {
                                                                _id: this.state._id,
                                                                comments: sampleRequest.processUpdates.garmentTechnologist.comments
                                                              };
                                                              SampleServices.completeGarment(request)
                                                                .then(response => {
                                                                  if (response.status === 200) {
                                                                    sampleRequest.processUpdates.garmentTechnologist = {
                                                                      ...response.text.data
                                                                    };
                                                                    this.setState({
                                                                      sampleRequest
                                                                    });
                                                                    this.props.getalertMessage("success", response.text.message);
                                                                  } else if (response.status == 401) {
                                                                    this.props.unauthorisedFunc();
                                                                  } else {
                                                                    this.props.getalertMessage("error", response.text.message);
                                                                  }
                                                                })
                                                                .catch(error => this.props.getalertMessage("error", error.toString()));
                                                            };



                                                            createCosting = e => {
                                                                e.preventDefault();
                                                                let objData = {};
                                                                objData.costingComments = this.state.sampleRequest.costingComments;
                                                                objData.costingProcess = this.state.sampleRequest.processUpdates.costing;
                                                                objData._id = this.state._id;
                                                                SampleServices.createCosting(objData)
                                                                  .then(response => {
                                                                    if (response.status === 200) {
                                                                      let sampleRequest = { ...this.state.sampleRequest };
                                                                      sampleRequest.costing = response.text.data;
                                                                      this.setState({
                                                                        sampleRequest
                                                                      });
                                                                      this.props.getalertMessage("success", response.text.message);
                                                                    } else if (response.status == 401) {
                                                                      this.props.unauthorisedFunc();
                                                                    } else {
                                                                      this.props.getalertMessage("error", response.text.message);
                                                                    }
                                                                  })
                                                                  .catch(error => this.props.getalertMessage("error", error.toString()));
                                                              };


                                                              completeCosting = e => {
                                                                  let sampleRequest = { ...this.state.sampleRequest };
                                                                  let request = {
                                                                    _id: this.state._id,
                                                                    comments: sampleRequest.processUpdates.costing.comments
                                                                  };
                                                                  SampleServices.completeCosting(request)
                                                                    .then(response => {
                                                                      if (response.status === 200) {
                                                                        sampleRequest.processUpdates.costing = response.text.data;
                                                                        this.setState({
                                                                          sampleRequest
                                                                        });
                                                                        this.props.getalertMessage("success", response.text.message);
                                                                      } else if (response.status == 401) {
                                                                        this.props.unauthorisedFunc();
                                                                      } else {
                                                                        this.props.getalertMessage("error", response.text.message);
                                                                      }
                                                                    })
                                                                    .catch(error => this.props.getalertMessage("error", error.toString()));
                                                                };

                              
                              



                     
  

    render() {
      // console.log(this.state.prefillInfo.SAMPLEREQUEST,"test")
      // console.log(this.state.sampleRequest,"sa")
      //console.log(this.state.sampleRequest.cad,"cad")
      //console.log(this.state.cuttingSizes,"csize")
      //console.log(this.props,"props");
      if (this.state.isLoading) {
        return <Loading />; // Show loading screen while isLoading is true
      }else if(this.props.rights.sampleRequest.sampleRequest.web.edit === false){
        return (
          <div className="un-auth">
            <img src={Warning} alt="warning" />
            You are not authorized to edit the Sample Request
            <button style={{marginTop:"20px"}} className="sv-btn"  onClick={() => {
                                            const route = this.props.history.location.state && this.props.history.location.state.route
                                            route !== undefined ? this.props.history.push(`/${route}`, {
                                                [`${route.toLowerCase()}`]: {
                                                    ...this.props.history.location.state[`${route.toLowerCase()}`]
                                                }
                                            }) : this.props.history.goBack()
                                        }}>
                                            
                                           Ok
                                        </button>
          </div>
        )
      }
        return (
          
            <div className="zoom-1">
               {/* <div class="container1">
               
                <button className="backbutton" onClick={() => {
                    const route = this.props.history.location.state && this.props.history.location.state.route
                    route !== undefined ? this.props.history.push(`/${route}`, {
                        [`${route.toLowerCase()}`]: {
                            ...this.props.history.location.state[`${route.toLowerCase()}`]
                        }
                    }) : this.props.history.goBack()
                }}>
                    
                   <img src={BackIcon} alt="back" className="backicon" />
                </button>
                <span className="title1" >Sample Request</span>
                <button className="button1"> <div className="logoutdiv"> <img src={LeftIcon} alt="logout" className="logouticon"/></div> 
                </button>
                </div> */}

<div className="container1">
                <MobileHeader />
                </div>

                <div className="container">


                <div className="samplemain-div" ref={this.orgReqRef}>
                    <div className="topdiv">
                        <div className="qrdiv">
                            <span className="qrhead">{this.state.sampleRequest.requestNumber}</span>
                            <div style={{display:"flex",justifyContent:"center",marginTop:"5px"}}>
                            <div className="qrimg"><img src={this.state.sampleRequest.qr} alt="qr" /></div>
                            </div>
                        </div>
                        <div className="qrrightdiv">
                            <div>
                                <div className="select-qr">
                                    <span className="label1">Magnum Style No.*</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                  name="styleReferenceId"
                  value={this.state.sampleRequest.styleReferenceId}
                  onInputChange={value => this.getMagnumStyleNo(value)}
                  //  onMenuOpen={() => this.getMagnumStyleNo("")}
                  onChange={val =>
                    this.getStyleReferenceInfo(
                      val !== null ? val.value : null 
                    )
                  }
                  placeholder="Find Style"
                  options={this.state.styleNoInfo}
                  // disabled={this.state.disabled}
                  onSelectResetsInput={false}
                  onBlurResetsInput={false}
                />
                 </div>

                                </div>
                            </div>
                            <div>
                                {/* <div className="input-qr">
                                <span className="label1">Magnum Style Name*</span>
                                <input type="text" className="input1" value={this.state.sampleRequest.magnumStyleName}  />
                                </div> */}
                                <MobileAppFields
                                isFormGroup={true}
                                  label={"Magnum Style Name*"}
                                  inputType="text"
                                  value={this.state.sampleRequest.magnumStyleName}
                                  disabled={true}
                                  />

                            </div>
                        </div>
                    </div>
                    <div className="qrbottomdiv">
                        <div className="qrb-left">
                          
                            {/* <div className="input-qr">
                            <span className="label1">Cust Ref No.</span>
                                <input type="text" className="input1" value={this.state.sampleRequest.customerRefNumber} />
                            </div> */}
                            <MobileAppFields
                            isFormGroup={true}
                              label={"Cust Ref No."}
                              inputType="text"
                              value={this.state.sampleRequest.customerRefNumber}
                              disabled={true}
                              />
                            
                            <div className="select-qr" style={{width:"100%"}}>
                            <span className="label1">Cust-Dept*</span>
                            <select 
                              className="dropdown1" 
                              value={`${this.state.sampleRequest.customer}-${this.state.sampleRequest.customerDepartmentId}`}
                              disabled={true}
                              style={{ backgroundColor: "#eee", cursor: "not-allowed" }}
                            >
  {this.state.customerList.map((customer,index)=>(
    <option
    key={index}
    id="select"
    title={`${customer.customerName}-${customer.departmentName}`}
    name={index}
    value={`${customer._id}-${customer.departmentId}`}
  >
    {customer.customerName}-{customer.departmentName}
  </option>
  ))}
{/* <option value={`${this.state.sampleRequest.customer}-${this.state.sampleRequest.customerDepartmentId}`}>
    {`${this.state.sampleRequest.customer}-${this.state.sampleRequest.customerDepartmentId}`}
  </option> */}
  {/* {this.state.options.map((opt) => (
    <option key={opt.id} value={`${opt.customer}-${opt.customerDepartmentId}`}>
      {opt.customer} - {opt.customerDepartmentId}
    </option>
  ))} */}
</select>
                            {/* <CustomerDeptSelectMb
              value={`${this.state.sampleRequest.customer}-${this.state.sampleRequest.customerDepartmentId}`}
              // toolTip={this.state.toolTip}
              // options={this.state.customerList}
              // onChange={this.props.updateCustomerDept}
              disabled={true}
            /> */}
                            </div>
                        
                        </div>
                        <div className="qrb-right">
                            {/* <div className="select-qr1">
                            <span className="label1">Source of Request*</span>
                            <select class="dropdown1" value={this.state.sampleRequest.typeOfRequest} onChange={(e) => this.updateSampleRequest("typeOfRequest", e.target.value)} >
                                    {options.typeOfRequest.map((sorReq)=>(
                                      <option value="">

                                      </option>
                                    ))}
                                    {options !== undefined &&
                                                  options.typeOfRequest.map((data, i) => (
                                                    <option
                                                      key={i}
                                                      value={data.value}
                                                      // disabled={isBoolean(data.disabled) ? !data.disabled : false}
                                                    >
                                                      {data.label}
                                                    </option>
                                                  ))}
                                    </select>
                            </div> */}
                            <MobileAppFields
                            isFormGroup={true}
                              label={"Source of Request*"}
                              inputName="typeOfRequest"
                              value={this.state.sampleRequest.typeOfRequest}
                              onChange={this.updateSampleRequest}
                              options={options.typeOfRequest}
                              inputType="select"
                              />
                            {/* <div className="select-qr1">
                            <span className="label1">Sample Type*</span>
                                    <select
  className="dropdown1"
  value={this.state.sampleRequest.sampleType || ""}
  onChange={(e) => this.updateSampleRequest("sampleType", e.target.value)}
>
  {this.state.prefillInfo.SAMPLEREQUEST &&
  this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE
    ? this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE.map((data, i) => (
        <option key={i} value={data.value}>
          {data.label}
        </option>
      ))
    : null}
</select>

                            </div> */}
                            <MobileAppFields
                            isFormGroup={true}
                              label={"Sample Type*"}
                              inputName="sampleType"
                              value={this.state.sampleRequest.sampleType || ""}
                              onChange={this.updateSampleRequest}
                              options={(this.state.prefillInfo.SAMPLEREQUEST && this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE) || []}

                              inputType="select"
                              
                              />

                        </div>
                    </div>
                </div>


                {this.state.showStickyHeader && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: "#fff",
      zIndex: 1000,
      padding: "10px 20px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    }}
  >
    

    <div className="sticky-form-wrapper">
  <div className="sticky-form-row">
    <div className="sticky-form-field mobileAppAsync">
      <Async
        name="styleReferenceId"
        value={this.state.sampleRequest.styleReferenceId}
        onInputChange={(value) => this.getMagnumStyleNo(value)}
        // onMenuOpen={() => this.getMagnumStyleNo("")}
        onChange={(val) =>
          this.getStyleReferenceInfo(val !== null ? val.value : null)
        }
        placeholder="Find Style"
        options={this.state.styleNoInfo}
      />
    </div>
    <div className="sticky-form-field">
      <MobileAppFields
        isFormGroup={false}
        inputType="text"
        value={this.state.sampleRequest.magnumStyleName}
        disabled={true}
      />
    </div>
  </div>

  <div className="sticky-form-row">
    <div className="sticky-form-field">
      <MobileAppFields
        isFormGroup={false}
        inputType="text"
        value={this.state.sampleRequest.customerRefNumber}
        disabled={true}
      />
    </div>
    <div className="sticky-form-field">
      <select
        className="dropdown1"
        value={`${this.state.sampleRequest.customer}-${this.state.sampleRequest.customerDepartmentId}`}
        disabled={true}
        style={{ backgroundColor: "#eee", cursor: "not-allowed", width: "100%" }}
      >
        {this.state.customerList.map((customer, index) => (
          <option
            key={index}
            title={`${customer.customerName}-${customer.departmentName}`}
            value={`${customer._id}-${customer.departmentId}`}
          >
            {customer.customerName}-{customer.departmentName}
          </option>
        ))}
      </select>
    </div>
  </div>

  <div className="sticky-form-row">
    <div className="sticky-form-field">
      <MobileAppFields
        isFormGroup={false}
        inputName="typeOfRequest"
        value={this.state.sampleRequest.typeOfRequest}
        onChange={this.updateSampleRequest}
        options={options.typeOfRequest}
        inputType="select"
      />
    </div>
    <div className="sticky-form-field">
      <MobileAppFields
        isFormGroup={false}
        inputName="sampleType"
        value={this.state.sampleRequest.sampleType || ""}
        onChange={this.updateSampleRequest}
        options={
          (this.state.prefillInfo.SAMPLEREQUEST &&
            this.state.prefillInfo.SAMPLEREQUEST.SAMPLETYPE) ||
          []
        }
        inputType="select"
      />
    </div>
  </div>
</div>
  </div>
)}
                <div className="req">Request</div>
                <div className="org-req">
                    <span className="label1" style={{marginBottom:"6px"}}>Origination of Request *</span>
                    <select class="dropdown1" value={this.state.sampleRequest.originationOfRequest}
                      onChange={(e) => this.updateSampleRequest("originationOfRequest", e.target.value)}
                    >
                    {this.state.prefillInfo.SAMPLEREQUEST &&
  this.state.prefillInfo.SAMPLEREQUEST.ORIGINATIONOFREQUEST
    ? this.state.prefillInfo.SAMPLEREQUEST.ORIGINATIONOFREQUEST.map((data, i) => (
        <option key={i} value={data.value}>
          {data.label}
        </option>
      ))
    : null}
                                    </select>
                </div>

                <div className="mgtec">
                    <div className="mgtec-label">Magnum Technologist</div>
                    <div className="mgtec-val">{this.state.sampleRequest.magnumTechnologist}</div>
                </div>
                <div className="dacr">
                    <div className="dacr-label">Date Created</div>
                    <div className="dacr-val">{moment(this.state.sampleRequest.orderDate).format("HH:mm DD MMM YYYY")}</div>
                </div>


                <div className="samp-but">
                    <div>
                    <button className="but-sam" onClick={this.createSample}>Create Request</button>
                    </div>
                    <div>
                    <button className="but-sam1">Duplicate</button>
                    </div>
                </div>


      {/* <div className="sample-container">
        <h2 className="sample-title">Sample Request</h2>
        <div className="sample-grid">
          {/* Left Side *
  <div className="sample-column">
  {[
    { label: "Sample", key: "sample" },
    { label: "Trim", key: "trim" },
    { label: "Cutting", key: "cutting" },
    { label: "Embellishment", key: "embellishment" },
    { label: "Wash", key: "wash" },
    { label: "Grading", key: "qc" },
    { label: "Marker", key: "marker" },
  ].map(({ label, key }, index) => {
    const permissionKey = key === "qc" ? "QC" : key; // Change "qc" to "QC" only for permissions

    const hasPermission =
      this.props.rights &&
      this.props.rights.sampleRequest &&
      this.props.rights.sampleRequest[permissionKey] &&
      this.props.rights.sampleRequest[permissionKey].web &&
      this.props.rights.sampleRequest[permissionKey].web.edit;
    return (
      hasPermission && (
    <div key={index} className="sample-row">
      <span>{label}</span>
      <label className="switch">
        <input
          style={{ position: "static", opacity: "1" }}
          type="checkbox"
          checked={this.state.sampleRequest.toggle[key]} // Accessing toggle.sample, toggle.3d, etc.
          onChange={() =>  this.toggleChange(key)} // Sending toggle.sample, toggle.3d
        />
        <span className="slider round"></span>
      </label>
    </div>
      )
    )
  })}
</div>


          {/* Right Side 
          <div className="sample-column">
  {[
    { label: "3D", key: "cad" },
    { label: "Fabric", key: "fabric" },
    { label: "Pattern", key: "pattern" },
    { label: "Sewing", key: "sewing" },
    { label: "Embroidery", key: "embroidery" },
    { label: "Dispatch", key: "dispatch" },
    { label: "Sign Off", key: "signOff" } // Replacing space with camelCase for better state keys
  ].map(({ label, key }, index) => {
    const permissionKey = key === "signOff" ? "signoff" : key; // Change "signOff" to "signoff" only for permissions

    const hasPermission =
      this.props.rights &&
      this.props.rights.sampleRequest &&
      this.props.rights.sampleRequest[permissionKey] && 
      this.props.rights.sampleRequest[permissionKey].web &&
      this.props.rights.sampleRequest[permissionKey].web.edit;
    return(
      hasPermission && (
    <div key={index} className="sample-row">
      <span>{label}</span>
      <label className="switch">
        <input
          style={{ position: "static", opacity: "1" }}
          type="checkbox"
          checked={this.state.sampleRequest.toggle[key]} // Accessing state using a proper key
          onChange={() =>  this.toggleChange(key)} // Sending the correct key to toggle
        />
        <span className="slider round"></span>
      </label>
    </div>
      )
    )
})}
</div>

        </div>
      </div> */}



<div className="sample-container">
  <h2 className="sample-title">Sample Request</h2>
  <div className="sample-grid">
    {[
      { label: "Sample", key: "sample" },
      { label:"GarmentTech", key:"garmentTechnologist", permissionKey:"garmentTech"},
      { label: "3D", key: "cad" },
      { label: "Fabric", key: "fabric" },
      { label: "Trim", key: "trim" },
      { label: "Pattern", key: "pattern" },
      { label: "Cutting", key: "cutting" },
      { label: "Sewing", key: "sewing" },
      { label: "Marker", key: "marker" },
      { label: "Embellishment", key: "embellishment" },
      { label: "Embroidery", key: "embroidery" },
      { label: "Wash", key: "wash" },
      { label: "Dispatch", key: "dispatch" },
      { label: "Grading", key: "qc", permissionKey: "QC" },
      {label:"Costing", key:"costing"},
      { label: "Sign Off", key: "signOff", permissionKey: "signoff" }
    ].map(({ label, key, permissionKey = key }, index) => {
      const hasPermission =
        this.props.rights &&
        this.props.rights.sampleRequest &&
        this.props.rights.sampleRequest[permissionKey] &&
        this.props.rights.sampleRequest[permissionKey].web &&
        this.props.rights.sampleRequest[permissionKey].web.edit;

      return (
        hasPermission && (
          <div key={index} className="sample-row">
            <span>{label}</span>
            <label className="switch">
              <input
                style={{ position: "static", opacity: "1" }}
                type="checkbox"
                checked={this.state.sampleRequest.toggle[key]}
                onChange={() => this.toggleChange(key)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        )
      );
    })}
  </div>
</div>


      <div className="save-btn">
      <button  className="sv-btn" onClick={this.createSample}>Save</button>
      </div>


      <div className="ma-pro">
        <div className="ma-pro-txt">
      Manage Process
        </div>
      </div>



      {/* sample */}
      {this.props.rights.sampleRequest.sample.web.edit && this.state.sampleRequest.toggle.sample &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isSample")} style={{
            color: this.state.isSample ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isSample} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isSample ? "600": "400"}}
          >
            Sample
          </span>
        <i className={`fa ${this.state.isSample ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isSample && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                                <MbModuleHeader
                                  moduleName={"sample"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest.processUpdates.sample}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div style={{display:"flex",flexDirection:"column",gap:"3px",marginTop:"12px"}}>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  Awaiting Dev Sample
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      value={this.state.sampleRequest.sample.awaitingDevSample}
                      checked={this.state.sampleRequest.sample.awaitingDevSample}
                      // onChange={e => onChange(inputName, e.target.checked, index, i)}
                      onChange={e=>this.updateSampleModule("awaitingDevSample",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  Awaiting Design Sheet
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                    type="checkbox"
                    value={this.state.sampleRequest.sample.awaitingDevSheet}
                    checked={this.state.sampleRequest.sample.awaitingDevSheet}
                    // onChange={e => onChange(inputName, e.target.checked, index, i)}
                    onChange={e=>this.updateSampleModule("awaitingDevSheet",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                </div>


                                <div style={{display:"flex",gap:"10px",marginTop:"10px"}}>Sizes <img src={addicon} alt="" onClick={this.addSize} /></div>


                                <div className="sizes" style={{marginBottom:"20px"}}>
                                  {this.state.sampleRequest.sample.data.map((data,i)=>(
                                    <div className="size" style={{display:"flex",gap:"50px",marginTop:"15px"}}>
                                    <div className="select-qr" style={{marginTop:"0px",flex:"1"}}>
                                                        <div style={{ display: "flex", justifyContent: "space-between",alignItems:"center", width: "100%" }}>
    <span className="label1">Size</span>
    <img src={removeicon} alt="remove" style={{visibility:"hidden"}} />
  </div>
                                                            
                                                            {/* <select class="dropdown1" >
                                                            <option value="option1">Option 1</option>
                                                            <option value="option2">Option 2</option>
                                                            </select> */}
                                                            <MobileAppFields
                                                                                        isFormGroup={false}
                                                                                        inputType="select"
                                                                                        inputName="size"
                                                                                        value={data.size}
                                                                                        index={i}
                                                                                        onChange={this.updateSampleModule}
                                                                                        options={this.state.sizeList}
                                                                                        // disabled={this.state.disabled}
                                                                                      />
                        
                                                        </div>
                                                        <div className="select-qr" style={{marginTop:"0px",flex:"1"}}>
                                                        <div style={{ display: "flex", justifyContent: "space-between",alignItems:"center", width: "100%" }}>
    <span className="label1">Qty</span>
    <img src={removeicon} alt="remove" onClick={() => this.removeSize(i)} />
  </div>
                                                            
                                                            {/* <select class="dropdown1" >
                                                            <option value="option1">Option 1</option>
                                                            <option value="option2">Option 2</option>
                                                            </select> */}
                                                            <input
                            type="number"
                            min="0"
                            value={data.quantity}
                            disabled={this.state.disabled}
                            onChange={e =>
                              this.updateSampleModule(
                                e.target.name,
                                e.target.value,
                                i
                              )
                            }
                            class="input1"
                            name="quantity"
                            maxLength={"10"}
                          />
                        
                                                        </div>
                                                        </div>
                                  ))}
                                
                                </div>





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}
                                <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.sample.comments}
                                              label={"Comments"}
                                              onChange={this.updateSampleModule}
                                            />



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e=>this.createSampleModule(e)}>Save</button>
                                  <button className="du-co" onClick={e=>this.completeSampleModule(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}




      {/* GarmentTech */}
      {this.props.rights.sampleRequest.garmentTech.web.edit && this.state.sampleRequest.toggle.garmentTechnologist &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isGarmentTech")} style={{
            color: this.state.isGarmentTech ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isGarmentTech} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isGarmentTech ? "600": "400"}}
          >
            GarmentTech
          </span>
        <i className={`fa ${this.state.isGarmentTech ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isGarmentTech && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Magnum Style No.*</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                                <MbModuleHeader
                                  moduleName={"garmentTechnologist"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest.processUpdates.garmentTechnologist}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div style={{display:"flex",flexDirection:"column",gap:"3px",marginTop:"12px"}}>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  Marker Requirement
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      value={this.state.sampleRequest.garmentTechnologist.markerRequirements}
                      checked={this.state.sampleRequest.garmentTechnologist.markerRequirements}
                      // onChange={e => onChange(inputName, e.target.checked, index, i)}
                      onChange={e=>this.updateGarment("markerRequirements",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  SMV Ammendment
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                    type="checkbox"
                    value={this.state.sampleRequest.garmentTechnologist.smvAmmendment}
                    checked={this.state.sampleRequest.garmentTechnologist.smvAmmendment}
                    // onChange={e => onChange(inputName, e.target.checked, index, i)}
                    onChange={e=>this.updateGarment("smvAmmendment",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                </div>

                                <div style={{display:"flex",flexDirection:"column",gap:"3px",}}>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  Technical Issues
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      value={this.state.sampleRequest.garmentTechnologist.tiIssues}
                      checked={this.state.sampleRequest.garmentTechnologist.tiIssues}
                      // onChange={e => onChange(inputName, e.target.checked, index, i)}
                      onChange={e=>this.updateGarment("tiIssues",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  Trail Required?
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                    type="checkbox"
                    value={this.state.sampleRequest.garmentTechnologist.trailRequired}
                    checked={this.state.sampleRequest.garmentTechnologist.trailRequired}
                    // onChange={e => onChange(inputName, e.target.checked, index, i)}
                    onChange={e=>this.updateGarment("trailRequired",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                </div>

                                <div style={{display:"flex",flexDirection:"column",gap:"3px",}}>
                                  <div style={{display:"flex",justifyContent:"space-between"}}>
                                  Mock
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      value={this.state.sampleRequest.garmentTechnologist.mock}
                      checked={this.state.sampleRequest.garmentTechnologist.mock}
                      // onChange={e => onChange(inputName, e.target.checked, index, i)}
                      onChange={e=>this.updateGarment("mock",e.target.checked,)}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>
                                  
                                </div>


                                {/*  */}



                                <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"garmentTechComments"}
                                              value={this.state.sampleRequest.garmentTechnologist.garmentTechComments}
                                              label={"Garment Tech Comments"}
                                              onChange={this.updateGarment}
                                            />




                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}
                                <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comment"}
                                              value={this.state.sampleRequest.garmentTechnologist.comment}
                                              label={"Comments"}
                                              onChange={this.updateGarment}
                                            />



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e=>this.createGarment(e)}>Save</button>
                                  <button className="du-co" onClick={e=>this.completeGarment(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}




      {/* 3D */}
      {this.props.rights.sampleRequest.cad.web.edit && this.state.sampleRequest.toggle.cad &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("is3D")} style={{
            color: this.state.is3D ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.is3D} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.is3D ? "600": "400" }}
          >
            3D
          </span>
        <i className={`fa ${this.state.is3D ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.is3D && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> 
                                <MobileAppFields
                                isFormGroup={true}
                                  label={"Completed Date"}
                                  options={[{label:1,id:22,label:2,id:33}]}
                                  inputType="select"
                                  inputName="Completed Date"
                                  />
                                </div> */}


                                <MbModuleHeader
                                  moduleName={"cad"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.cad}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">3D Ref No.</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                  name="cadRefNo"
                  value={this.state.sampleRequest.cad.cadId}
                  onInputChange={e => this.getCADRefNumber(e)}
                  onChange={value =>
                     this.changeCADRefNum(value)
                     }
                  placeholder="Find 3D RefNo"
                  options={this.state.CADRefNumInfo}
                  // disabled={this.state.disabled}
                  // onSelectResetsInput={false}
                  // onBlurResetsInput={false}
                />
                 </div>

                                </div>
                                {/* <div className="select-qr" style={{flex:"1"}}> */}
                                    {/* <span className="label1">3D Name</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}
                                    <MobileAppFields
                                                                isFormGroup={true}
                                                                label={"3D Name"}
                                                                inputType="text"
                                                                inputName="cadName"
                                                                value={this.state.sampleRequest.cad.cadName}
                                                                // index={index}
                                                                onChange={this.cadUpdate}
                                                                // disabled={this.state.disabled}
                                                              />

                                {/* </div> */}
                                </div>








                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">3D Type</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {this.state.sampleRequest.cad && 
                            this.state.sampleRequest.cad.cadType && 
                            this.state.sampleRequest.cad.cadType.length > 0 
                              ? this.state.sampleRequest.cad.cadType.map(data => data.label).join(",\n ") 
                              : "-"}
                          </span>

                                </div>


                                
                                {/* <div className="select-qr" style={{width:"100%"}}> */}
                                    {/* <span className="label1">Print/EMB Type</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}
                                    <MobileAppFields
                                                                isFormGroup={true}
                                                                label="Print/EMB Type"
                                                                inputType="select"
                                                                inputName="printEmbType"
                                                                value={this.state.sampleRequest.cad && this.state.sampleRequest.cad.printEmbType}
                                                                options={
                                                                  this.state.cadPreFill
                                                                    ? this.state.cadPreFill.PRINTEMBTYPE
                                                                    : []
                                                                }
                                                                // index={index}
                                                                onChange={this.cadUpdate}
                                                                // disabled={this.state.disabled}
                                                              />

                                {/* </div> */}
                                </div>

                                <div>
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Border Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}
                                <MobileAppFields
                                                            isFormGroup={true}
                                                            label="Border Type"
                                                            inputType="select"
                                                            inputName="borderType"
                                                            value={this.state.sampleRequest.cad && this.state.sampleRequest.cad.borderType}
                                                            options={
                                                              this.state.cadPreFill
                                                                ? this.state.cadPreFill.BORDERTYPE
                                                                : []
                                                            }
                                                            // index={index}
                                                            onChange={this.cadUpdate}
                                                            // disabled={this.state.disabled}
                                                          />
                                </div>





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}

                                <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.cad.comments}
                                              label={"Comments"}
                                              onChange={this.updateCadValues}
                                            />



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e=>this.saveCAD(e)}>Save</button>
                                  <button className="du-co" onClick={e=>this.completeCAD(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}





      {/* Fabric */}
      {this.props.rights.sampleRequest.fabric.web.edit && this.state.sampleRequest.toggle.fabric &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isFabric")} style={{
            color: this.state.isFabric ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isFabric} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none",fontWeight: this.state.isFabric ? "600": "400"}}
          >
            Fabric
          </span>
        <i className={`fa ${this.state.isFabric ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isFabric && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                            <MbModuleHeader
                                  moduleName={"fabric"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.fabric}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div className="fabricaddbutton">
                                  <img src={addicon} alt="add" onClick={this.addFabric} />
                                </div>

                                {this.state.sampleRequest.fabric.map((fabricData, index) => (
          <div key={index} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.removeFabric(index)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Fabric ref no.</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Fabric Ref No*</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                                      name="fabricNumber"
                                      value={fabricData.fabricNumber}
                                      onInputChange={val =>
                                        this.getFabricNumber(val, index)
                                      }
                                      onChange={val =>
                                        this.getFabricInfo(val, index)
                                      }
                                      placeholder="Find Fabric"
                                      // onFocus={() =>
                                      //   this.props.clearDummyFabric(index)
                                      // }
                                      options={
                                        fabricData.fabricList ||
                                        this.state.fabricList
                                      }
                                      // disabled={this.state.disabled}
                                      // onSelectResetsInput={false}
                                      // onBlurResetsInput={false}
                                    />
                 </div>

                                </div>




                                {/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Fabric Name</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                                   <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType={"text"}
                                                          inputName={"fabricName"}
                                                          label="Fabric Name"
                                                          value={fabricData.fabricName}
                                                           index={index}
                                                          // label={"comments"}
                                                          onChange={this.updateFabricName}
                                                          // disabled={this.state.disabled}
                                                          max={25}
                                                        />



                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Position*</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                                <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Position*"
                                                                    inputType="select"
                                                                    inputName="fabricPosition"
                                                                    value={fabricData.fabricPosition}
                                                                    options={this.state.prefillInfo.SAMPLEREQUEST.POSITION || []}
                                                                    index={index}
                                                                    onChange={this.updateFabric}
                                                                    // disabled={this.state.disabled}
                                                                  />



                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Base No</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Base No</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {  fabricData.bNumber ? fabricData.bNumber 
                              : "-"}
                          </span>

                                </div>



                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Classification of Fabric</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Classification of Fabric</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {  fabricData.classificationOfFabric ? fabricData.classificationOfFabric 
                              : "-"}
                          </span>

                                </div>
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Quality</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Quality</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {  fabricData.quality ? fabricData.quality 
                              : "-"}
                          </span>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Count & Construction</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Count & Construction</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {  fabricData.countAndConstruction ? fabricData.countAndConstruction 
                              : "-"}
                          </span>

                                </div>

                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Fabric Origination</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                                                  <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Fabric Origination"
                                                                    inputType="select"
                                                                    inputName="fabricOrigination"
                                                                    value={fabricData.fabricOrigination}
                                                                    options={
                                                                      this.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION || []
                                                                    }
                                                                    index={index}
                                                                    onChange={this.updateFabric}
                                                                    // disabled={this.state.disabled}
                                                                  />

                                </div>

<div style={{marginTop:"20px",display:"flex",flexDirection:"column", gap:"10px"}}>
                                <div style={{display:"flex",alignItems:"center"}}>
                                  {/* <input
                                    type="radio"
                                    id="in-use"
                                    name="usage"
                                    value="in-use"
                                    checked={this.state.selectedOption === "in-use"}
                                    onChange={this.handleRadioChange}
                                  /> */}
                                                                    <MobileAppFields
                                                                      isFormGroup={false}
                                                                      inputType="radio"
                                                                      inputName={`fabricRadio${index}`}
                                                                      value={"inHse" + index}
                                                                      checked={fabricData.fabricRadio === "inHse"}
                                                                      index={index}
                                                                      onChange={(name, value) =>
                                                                        this.updateFabric(
                                                                          "fabricRadio",
                                                                          "inHse",
                                                                          index
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                  <label htmlFor="in-use">In Use</label>
                                </div>

                                 <div style={{display:"flex",alignItems:"center"}}>
                                  {/* <input
                                    type="radio"
                                    id="not-in-use"
                                    name="usage"
                                    value="not-in-use"
                                    checked={this.state.selectedOption === "not-in-use"}
                                    onChange={this.handleRadioChange}
                                  /> */}
                                  <MobileAppFields
                                                                      isFormGroup={false}
                                                                      inputType="radio"
                                                                      inputName={`fabricRadio${index}`}
                                                                      value={"notInHse" + index}
                                                                      checked={
                                                                        fabricData.fabricRadio === "notInHse"
                                                                      }
                                                                      index={index}
                                                                      onChange={() =>
                                                                        this.updateFabric(
                                                                          "fabricRadio",
                                                                          "notInHse",
                                                                          index
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                  <label htmlFor="not-in-use">Not in Use</label>
                                </div>

                                </div>

                                </div>
                                 ))}





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}


                                        <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"fabricComments"}
                                              value={this.state.sampleRequest.fabricComments}
                                              label={"Comments"}
                                              onChange={this.updateSampleRequest}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.checkValidation("save", e)}>Save</button>
                                  <button className="du-co" onClick={e => this.checkValidation("complete", e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}



      
      {/* Trim */}
      {this.props.rights.sampleRequest.trim.web.edit && this.state.sampleRequest.toggle.trim &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isTrim")} style={{
            color: this.state.isTrim ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isTrim} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isTrim ? "600": "400"}}
          >
            Trim
          </span>
        <i className={`fa ${this.state.isTrim ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isTrim && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                                <MbModuleHeader
                                  moduleName={"trim"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.trim}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div className="fabricaddbutton">
                                  <img src={addicon} alt="add" onClick={()=>this.addTrim("row1")} />
                                </div>

                                {this.state.sampleRequest.trim &&
                            this.state.sampleRequest.trim.row1 &&
                            this.state.sampleRequest.trim.row1.length &&
                            this.state.sampleRequest.trim.row1.map((trim, index) => (
          <div key={""} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.removeTrim("row1", index)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Trim Category*</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Trim Category*"
                                                                    inputType="select"
                                                                    inputName="trimCategory"
                                                                    value={trim.trimCategory}
                                                                    index={index}
                                                                    options={this.state.prefillInfo.TRIM.TRIMCATEGORY || []}
                                                                    onChange={this.updateTrimRow1}
                                                                    onInputChange={this.updateTrimRow1}
                                                                    // disabled={this.state.disabled}
                                                                  />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Trim Ref No.</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Trim Ref No*</span>
<div className="mobileAppAsync" style={{width:"100%"}}> 
<Async
                                      name="trimNumber"
                                      // clearable={false}
                                      value={trim.trimNumber}
                                      onInputChange={value =>
                                        this.getTrimRefNo(
                                          trim.trimCategory,
                                          value,
                                          index
                                        )
                                      }
                                      onChange={value =>
                                        this.getTrimInfo(value, index)
                                      }
                                      placeholder="Find trimRefNo"
                                      options={
                                        trim.trimList ? trim.trimList : []
                                      }
                                      // disabled={this.state.disabled}
                                      // onSelectResetsInput={false}
                                      // onBlurResetsInput={false}
                                    />
                 </div>
                 </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Description</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Description</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {  trim.description ? trim.description 
                              : "-"}
                          </span>

                                </div>


                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Quality</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Quality</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {  trim.quality ? trim.quality 
                              : "-"}
                          </span>

                                </div>


                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Size</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Size</span>
                                    {/* <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select> */}

                          <span className="completed-date-mdheader">
                          {trim.sizeNumber && trim.size ? `${trim.sizeNumber}-${trim.size}` : "-"}

                          </span>

                                </div>


                                </div>

                                

                                {/* <div>
                                  <input
                                    type="radio"
                                    id="in-use"
                                    name="usage"
                                    value="in-use"
                                    checked={this.state.selectedOption === "in-use"}
                                    onChange={this.handleRadioChange}
                                  />
                                  <label htmlFor="in-use">In Use</label>
                                </div>

                                 <div>
                                  <input
                                    type="radio"
                                    id="not-in-use"
                                    name="usage"
                                    value="not-in-use"
                                    checked={this.state.selectedOption === "not-in-use"}
                                    onChange={this.handleRadioChange}
                                  />
                                  <label htmlFor="not-in-use">Not in Use</label>
                                </div> */}



<div style={{marginTop:"20px",display:"flex",flexDirection:"column", gap:"10px"}}>
                                <div style={{display:"flex",alignItems:"center"}}>
                                  {/* <input
                                    type="radio"
                                    id="in-use"
                                    name="usage"
                                    value="in-use"
                                    checked={this.state.selectedOption === "in-use"}
                                    onChange={this.handleRadioChange}
                                  /> */}
                                                                    <MobileAppFields
                                                                      isFormGroup={false}
                                                                      inputType="radio"
                                                                      inputName={"trimRadio" + index}
                                                                      value={"inHsetrimRadio" + index}
                                                                      checked={trim.trimRadio === "inHse"}
                                                                      index={index}
                                                                      onChange={(name, value) =>
                                                                        this.updateTrimRow1(
                                                                          "trimRadio",
                                                                          "inHse",
                                                                          index
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                  <label htmlFor="in-use">In Use</label>
                                </div>

                                 <div style={{display:"flex",alignItems:"center"}}>
                                  {/* <input
                                    type="radio"
                                    id="not-in-use"
                                    name="usage"
                                    value="not-in-use"
                                    checked={this.state.selectedOption === "not-in-use"}
                                    onChange={this.handleRadioChange}
                                  /> */}
                                  <MobileAppFields
                                                                     isFormGroup={false}
                                                                     inputType="radio"
                                                                     inputName={`trimRadio${index}`}
                                                                     value={"notInHsetrimRadio" + index}
                                                                     checked={trim.trimRadio === "notInHse"}
                                                                     index={index}
                                                                     onChange={(name, value) =>
                                                                       this.updateTrimRow1(
                                                                         "trimRadio",
                                                                         "notInHse",
                                                                         index
                                                                       )
                                                                     }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                  <label htmlFor="not-in-use">Not in Use</label>
                                </div>

                                </div>

                                </div>
                                 ))}





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}


                                          <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comment"}
                                              value={this.state.sampleRequest.trim.comment}
                                              label={"Comments"}
                                              onChange={this.updateTrim}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.checkValidationTrim("save", e)}>Save</button>
                                  <button className="du-co" onClick={e => this.checkValidationTrim("complete", e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}


        {/* Pattern */}
        {this.props.rights.sampleRequest.pattern.web.edit && this.state.sampleRequest.toggle.pattern &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isPattern")} style={{
            color: this.state.isPattern ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isPattern} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none" , fontWeight: this.state.isPattern ? "600": "400"}}
          >
            Pattern
          </span>
        <i className={`fa ${this.state.isPattern ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isPattern && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                                <MbModuleHeader
                                  moduleName={"pattern"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.pattern}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Pattern Master Name</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Pattern Master Name</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                  name="patternMaster"
                  // value={this.state.sampleRequest.pattern.patternMaster}
                  value={
                    this.state.sampleRequest.pattern.patternMaster
                      ? this.state.prefillInfo.PATTERNMASTER.find(
                          option => option.value === this.state.sampleRequest.pattern.patternMaster
                        )
                      : null
                  }
                  // onInputChange={e =>
                  //   this.getPatternMaster(e, "patternMaster")
                  // }
                  // onChange={value =>
                  //   this.updatePattern(
                  //     "patternMaster",
                  //     value.value
                  //   )
                  // }
                  onChange={value =>
                    this.updatePattern("patternMaster", value ? value.value : null)
                  }
                  placeholder="Find Pattern Master "
                  options={this.state.prefillInfo.PATTERNMASTER}
                  // disabled={this.state.disabled}
                  // onSelectResetsInput={false}
                  // onBlurResetsInput={false}
                  isClearable={false}
                />
                 </div>

                                </div>



                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Pattern Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}

                                <MobileAppFields
                                                              isFormGroup={true}
                                                              label="Pattern Type"
                                                              inputType="select"
                                                              inputName="patternType"
                                                              value={this.state.sampleRequest.pattern.patternType}
                                                              options={this.state.prefillInfo.PATTERNTYPE || []}
                                                              onChange={this.updatePattern}
                                                              // disabled={this.state.disabled}
                                                            />
                                </div>








                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Block Ref Used</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


                                <MobileAppFields
                                                              isFormGroup={true}
                                                              label="Block Ref Used"
                                                              inputType="text"
                                                              inputName="blockRefNumber"
                                                              value={this.state.sampleRequest.pattern.blockRefNumber}
                                                              onChange={this.updatePattern}
                                                              // disabled={this.state.disabled}
                                                            />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Approval Status</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


                                <MobileAppFields
                                                              isFormGroup={true}
                                                              label="Approval Status"
                                                              inputType="select"
                                                              inputName="approvalStatus"
                                                              value={this.state.sampleRequest.pattern.approvalStatus}
                                                              options={[
                                                                {
                                                                  label: "approved",
                                                                  value: "approved"
                                                                },
                                                                {
                                                                  label: "pending",
                                                                  value: "pending"
                                                                },
                                                                {
                                                                  label: "rejected",
                                                                  value: "rejected"
                                                                }
                                                              ]}
                                                              // index={index}
                                                              onChange={this.updatePattern}
                                                              // disabled={this.state.disabled}
                                                            />
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"center"}}>
                                Trail Required
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      name="trailRequired"
                      value={this.state.sampleRequest.pattern.trailRequired}
                      onChange={e => this.updatePattern("trailRequired", e.target.checked,) }
                      checked={this.state.sampleRequest.pattern.trailRequired}
                      // checked={true}
                      // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>


                                  <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>Logs <img src={addicon} alt="add" onClick={this.addPatternLog} style={{ cursor: "pointer" }} /></div>
                                  {this.state.sampleRequest.pattern.logs.map((log,i) => (
                                  <div style={{display:"flex",gap:"10px",marginTop:"15px"}}>
                                    <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                                      <span>{log.timeIn !== "" ? moment(log.timeIn).format('MMMM Do YYYY, hh:mm') : ""}</span>
                                      <div><button className="log-btn" onClick={()=>this.updatePatternCheck("timeIn", i)}>Time In</button></div>
                                      {/* <div className="select-qr" >
                                    <span className="label1">Break Time (Duration)</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                </div> */}


                                <MobileAppFields
                                                            isFormGroup={true}
                                                            inputType="time"
                                                            maxlength={23}
                                                            inputName="breakTime"
                                                            label="Break Time (Duration)"
                                                            value={log.breakTime}
                                                            onChange={(name, value) =>
                                                              this.updatePatternLog(name, value, i)
                                                            }
                                                            // disabled={this.state.disabled}
                                                          />
                                      
                                  
                                </div>

                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}}>

                                <span>{log.timeOut !== "" ? moment(log.timeOut).format('MMMM Do YYYY, hh:mm') : ""}</span>
                                <div style={{display:"flex",justifyContent:"space-between"}}><button className="log-btn"  onClick={()=>this.updatePatternCheck("timeOut", i)}>Time Out</button> <img src={removeicon} alt="remove" onClick={()=>this.removePatternLog(i)} /></div>
                                  {/* <div className="select-qr" >
                                    <span className="label1">Reason</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                  </div> */}


                                  <MobileAppFields
                                                              isFormGroup={true}
                                                              inputType="text"
                                                              inputName="reason"
                                                              label="Reason"
                                                              value={log.reason}
                                                              // onChange={(e) => this.updatePatternLog("reason", e.target.value, i)
                                                              // }
                                                              onChange={(name, value) =>
                                                                this.updatePatternLog(name, value, i)
                                                              }
                                                              // disabled={this.state.disabled}
                                                            />
                                  </div>
                                  </div>
                                  ))}
                          





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}


<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comment"}
                                              value={this.state.sampleRequest.pattern.comment}
                                              label={"Comments"}
                                              onChange={this.updatePattern}
                                            />  




                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.createPattern(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completePattern(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
        )}



      {/* Cutting */}
      {this.props.rights.sampleRequest.cutting.web.edit && this.state.sampleRequest.toggle.cutting &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isCutting")} style={{
            color: this.state.isCutting ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isCutting} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isCutting ? "600": "400"}}
          >
            Cutting
          </span>
        <i className={`fa ${this.state.isCutting ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isCutting && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}
                                <MbModuleHeader
                                  moduleName={"cutting"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.cutting}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Cutting Master Name</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Cutting Master Name</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                 name="cuttingMaster"
                 value={this.state.sampleRequest.cutting.cuttingMasterName}
                 //   onInputChange={e =>
                 //     this.getPatternMaster(e, "cuttingMaster")
                 //   }
                 onChange={e =>
                   this.updateCutting("cuttingMasterName", e)
                 }
                 placeholder="Cutting master Name"
                 options={this.state.prefillInfo.CUTTINGMASTER}
                //  disabled={this.state.disabled}
                />
                 </div>

                                </div>


                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Cutting Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}
                                <MobileAppFields
                                                      isFormGroup={true}
                                                      inputType="select"
                                                      inputName="cuttingType"
                                                      value={this.state.sampleRequest.cutting.cuttingType}
                                                      label={"Cutting type "}
                                                      options={this.state.prefillInfo.CUTTINGTYPE}
                                                      onChange={this.updateCutting}
                                                      // disabled={this.state.disabled}
                                                    />
                                </div>








                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Size</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}



                                <MobileAppFields
                                                      isFormGroup={true}
                                                      inputType="select"
                                                      inputName="size"
                                                      value={this.state.sampleRequest.cutting.size}
                                                      label={"Size "}
                                                      options={this.state.sampleRequest &&
                                                        this.state.sampleRequest.sample &&
                                                        this.state.sampleRequest.sample.data
                                                          ? this.state.sampleRequest.sample.data
                                                              .filter(x => x.size) // Ensures size exists
                                                              .map(x => ({ label: x.size, value: x.size })) // Creates label-value pairs
                                                          : [] // Fallback if data is missing
                                                      }
                                                      onChange={this.updateCutting}
                                                      // disabled={this.state.disabled}
                                                    />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Approval Status</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}

                                <MobileAppFields
                                                      isFormGroup={true}
                                                      inputType="select"
                                                      inputName="approvalStatus"
                                                      label={"Approval Status "}
                                                      value={this.state.sampleRequest.cutting.approvalStatus}
                                                      options={[
                                                        {
                                                          label: "approved",
                                                          value: "approved"
                                                        },
                                                        {
                                                          label: "pending",
                                                          value: "pending"
                                                        },
                                                        {
                                                          label: "rejected",
                                                          value: "rejected"
                                                        }
                                                      ]}
                                                      onChange={this.updateCutting}
                                                      // disabled={this.state.disabled}
                                                    />


                                </div>




                                  {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>Logs <img src={addicon} alt="add" onClick={this.handleAddLog} style={{ cursor: "pointer" }} /></div>
                                  {this.state.logs.map((log) => (
                                  <div style={{display:"flex",gap:"10px",marginTop:"15px"}}>
                                    <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                                      <div><button className="log-btn">Time In</button></div>
                                      <div className="select-qr" >
                                    <span className="label1">Break Time (Duration)</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                </div>
                                      
                                  
                                </div>

                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}}>

                                  
                                <div style={{display:"flex",justifyContent:"space-between"}}><button className="log-btn">Time Out</button> <img src={removeicon} alt="remove" onClick={()=>this.handleLogRemove(log.id)} /></div>
                                  <div className="select-qr" >
                                    <span className="label1">Reason</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                  </div>
                                  </div>
                                  </div>
                                  ))} */}



<div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>Logs <img src={addicon} alt="add" onClick={this.addCuttingLog} style={{ cursor: "pointer" }} /></div>
                                  {this.state.sampleRequest.cutting.logs.map((log,i) => (
                                  <div style={{display:"flex",gap:"10px",marginTop:"15px"}}>
                                    <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                                      <span>{log.timeIn !== "" ? moment(log.timeIn).format('MMMM Do YYYY, hh:mm') : ""}</span>
                                      <div><button className="log-btn" onClick={()=>this.updateCuttingCheck("timeIn", i)}>Time In</button></div>
                                      {/* <div className="select-qr" >
                                    <span className="label1">Break Time (Duration)</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                </div> */}


                                <MobileAppFields
                                                            isFormGroup={true}
                                                            inputType="time"
                                                            maxlength={23}
                                                            inputName="breakTime"
                                                            label="Break Time (Duration)"
                                                            value={log.breakTime}
                                                            onChange={(name, value) =>
                                                              this.updateCuttingLog(name, value, i)
                                                            }
                                                            // disabled={this.state.disabled}
                                                          />
                                      
                                  
                                </div>

                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}}>

                                <span>{log.timeOut !== "" ? moment(log.timeOut).format('MMMM Do YYYY, hh:mm') : ""}</span>
                                <div style={{display:"flex",justifyContent:"space-between"}}><button className="log-btn"  onClick={()=>this.updateCuttingCheck("timeOut", i)}>Time Out</button> <img src={removeicon} alt="remove" onClick={()=>this.removeCuttingLog(i)} /></div>
                                  {/* <div className="select-qr" >
                                    <span className="label1">Reason</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                  </div> */}


                                  <MobileAppFields
                                                              isFormGroup={true}
                                                              inputType="text"
                                                              inputName="reason"
                                                              label="Reason"
                                                              value={log.reason}
                                                              // onChange={(e) => this.updatePatternLog("reason", e.target.value, i)
                                                              // }
                                                              onChange={(name, value) =>
                                                                this.updateCuttingLog(name, value, i)
                                                              }
                                                              // disabled={this.state.disabled}
                                                            />
                                  </div>
                                  </div>
                                  ))}
                          





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}

<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.cutting.comments}
                                              label={"Comments"}
                                              onChange={this.updateCutting}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.createCutting(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completeCutting(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}



        {/* Sewing */}
        {this.props.rights.sampleRequest.sewing.web.edit && this.state.sampleRequest.toggle.sewing &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isSewing")} style={{
            color: this.state.isSewing ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isSewing} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isSewing ? "600": "400"}}
          >
            Sewing
          </span>
        <i className={`fa ${this.state.isSewing ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isSewing && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}


<MbModuleHeader
                                  moduleName={"sewing"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.sewing}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  PLACEOFSEWING={this.state.prefillInfo.SAMPLEREQUEST
                                    .PLACEOFSEWING}
                                    placeOfSewing={this.state.sampleRequest.sewing.placeOfSewing}
                                    updateSewing={this.updateSewing1}
                                  
                                  />



{/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Cutting Master Name</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                                    name="tailorName"
                                    value={value.tailorName}
                                    // onInputChange={this.getFabricNumber}
                                    onChange={value =>
                                      this.props.updateSewing(
                                        "tailorName",
                                        value,
                                        index
                                      )
                                    }
                                    placeholder="Tailor Name"
                                    options={this.state.assignedToList}
                                    disabled={this.state.disabled}
                                  />
                 </div>

                                </div> */}


                                <div className="fabricaddbutton" style={{justifyContent:"space-between",alignItems:"center"}}>
                                <span className="label1">Sewing</span>
                                  <img src={addicon} alt="add" onClick={this.addSewing} />
                                </div>

                                {this.state.sampleRequest.sewing.sewingData.map((value, index) => (
          <div key={index} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.removeSewing(index)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Tailor Name</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Tailor Name</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                                    name="tailorName"
                                    value={value.tailorName}
                                    // onInputChange={this.getFabricNumber}
                                    onChange={value =>
                                      this.updateSewing(
                                        "tailorName",
                                        value,
                                        index
                                      )
                                    }
                                    placeholder="Tailor Name"
                                    options={this.state.prefillInfo.SYSTEMSAMPLEREQUEST.TAILORSNAME}
                                    // disabled={this.state.disabled}
                                  />
                 </div>

                                </div> 


                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Sewing Type</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Sewing Type"
                                                                  inputType="select"
                                                                  inputName="sewingType"
                                                                  value={value.sewingType}
                                                                  options={this.state.prefillInfo.SAMPLEREQUEST
                                                                    .SEWINGTYPE || []}
                                                                  index={index}
                                                                  onChange={this.updateSewing}
                                                                  // disabled={this.state.disabled}
                                                                />


                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Size</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

<MobileAppFields
                                                      isFormGroup={true}
                                                      inputType="select"
                                                      inputName="size"
                                                      value={value.size}
                                                      label={"Size "}
                                                      index={index}
                                                      options={this.state.sampleRequest &&
                                                        this.state.sampleRequest.sample &&
                                                        this.state.sampleRequest.sample.data
                                                          ? this.state.sampleRequest.sample.data
                                                              .filter(x => x.size) // Ensures size exists
                                                              .map(x => ({ label: x.size, value: x.size })) // Creates label-value pairs
                                                          : [] // Fallback if data is missing
                                                      }
                                                      onChange={this.updateSewing}
                                                      // disabled={this.state.disabled}
                                                    />

                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Qty</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Qty"
                                                                  inputType="text"
                                                                  inputName="quantity"
                                                                  value={value.quantity}
                                                                  index={index}
                                                                  onChange={this.updateSewing}
                                                                  // disabled={this.state.disabled}
                                                                />
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Approval Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Approval Status"
                                                                  inputType="select"
                                                                  inputName="approvalStatus"
                                                                  value={value.approvalStatus}
                                                                  options={[
                                                                    {
                                                                      label: "approved",
                                                                      value: "approved"
                                                                    },
                                                                    {
                                                                      label: "pending",
                                                                      value: "pending"
                                                                    },
                                                                    {
                                                                      label: "rejected",
                                                                      value: "rejected"
                                                                    }
                                                                  ]}
                                                                  index={index}
                                                                  onChange={this.updateSewing}
                                                                  // disabled={this.state.disabled}
                                                                />

                                                                {value.approvalStatus == "rejected" && (
                                                                                                  <MobileAppFields
                                                                                                    isFormGroup={true}
                                                                                                    label="Reason"
                                                                                                    inputType="text"
                                                                                                    inputName="rejected"
                                                                                                    value={value.rejected}
                                                                                                    index={index}
                                                                                                    onChange={this.updateSewing}
                                                                                                    disabled={this.state.disabled}
                                                                                                  />
                                                                                                )}
                                </div>

                                

                                {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>Logs <img src={addicon} alt="add" onClick={this.handleAddLog} style={{ cursor: "pointer" }} /></div>
                                  {this.state.logs.map((log) => (
                                  <div style={{display:"flex",gap:"10px",marginTop:"15px"}}>
                                    <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                                      <div><button className="log-btn">Time In</button></div>
                                      <div className="select-qr" >
                                    <span className="label1">Break Time (Duration)</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                </div>
                                      
                                  
                                </div>

                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}}>

                                  
                                <div style={{display:"flex",justifyContent:"space-between"}}><button className="log-btn">Time Out</button> <img src={removeicon} alt="remove" onClick={()=>this.handleLogRemove(log.id)} /></div>
                                  <div className="select-qr" >
                                    <span className="label1">Reason</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                  </div>
                                  </div>
                                  </div>
                                  ))} */}


<div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>Logs <img src={addicon} alt="add" onClick={()=>this.addSewingLog(index)} style={{ cursor: "pointer" }} /></div>
                                {value.logs.map((log, i) => (
                                  <div style={{display:"flex",gap:"10px",marginTop:"15px"}}>
                                    <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                                      <span>{log.timeIn !== "" ? moment(log.timeIn).format('MMMM Do YYYY, hh:mm') : ""}</span>
                                      <div><button className="log-btn" onClick={()=>this.updateSewingCheck("timeIn", i,index)}>Time In</button></div>
                                      {/* <div className="select-qr" >
                                    <span className="label1">Break Time (Duration)</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                </div> */}


                                <MobileAppFields
                                                            isFormGroup={true}
                                                            inputType="time"
                                                            maxlength={23}
                                                            inputName="breakTime"
                                                            label="Break Time (Duration)"
                                                            value={log.breakTime}
                                                            onChange={(name, value) =>
                                                              this.updateSewingLog(name, value, i, index)
                                                            }
                                                            // disabled={this.state.disabled}
                                                          />
                                      
                                  
                                </div>

                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",gap:"10px"}}>

                                <span>{log.timeOut !== "" ? moment(log.timeOut).format('MMMM Do YYYY, hh:mm') : ""}</span>
                                <div style={{display:"flex",justifyContent:"space-between"}}><button className="log-btn"  onClick={()=>this.updateSewingCheck("timeOut", i, index)}>Time Out</button> <img src={removeicon} alt="remove" onClick={()=>this.removeSewingLog(i, index)} /></div>
                                  {/* <div className="select-qr" >
                                    <span className="label1">Reason</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>
                                  </div> */}


                                  <MobileAppFields
                                                              isFormGroup={true}
                                                              inputType="text"
                                                              inputName="reason"
                                                              label="Reason"
                                                              value={log.reason}
                                                              // onChange={(e) => this.updatePatternLog("reason", e.target.value, i)
                                                              // }
                                                              onChange={(name, value) =>
                                                                this.updateSewingLog(name, value, i,index)
                                                              }
                                                              // disabled={this.state.disabled}
                                                            />
                                  </div>
                                  </div>
                                  ))}

                                </div>
                                 ))}

<div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>
Smocking/Shirring
                                  <label className="switch">
                    <input
                     
                     style={{position:"static",opacity:"1"}}
                       type="checkbox"
                       name="smokingOrShiring"
                       value={this.state.sampleRequest.sewing.smokingOrShiring}
                      //  onChange={e => {
                      //   this.updateSewing1(e)
                      // }}
                      onChange={e => this.updateSewing1("smokingOrShiring", e.target.checked,) }
                       checked={this.state.sampleRequest.sewing.smokingOrShiring}
                       // checked={true}
                       // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>




                                  {this.state.sampleRequest.sewing.smokingOrShiring &&(
                                    <React.Fragment>
                                       <div className="fabricaddbutton">
                                  <img src={addicon} alt="add" onClick={()=>this.smockingShirringaddTrim()} />
                                </div>
                                {this.state.sampleRequest.sewing.trimData && this.state.sampleRequest.sewing.trimData.length && this.state.sampleRequest.sewing.trimData.map((value, index) => (
                                    <React.Fragment>
                                      <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.smockingShirringremoveTrim(
                                              "row2",
                                              index
                                            )} />
                                </div>
                                      <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Fabric ref no.</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

{/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Fabric ref no.</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                                      name="fabricNumber"
                                      value={fabricData.fabricNumber}
                                      onInputChange={val =>
                                        this.getFabricNumber(val, index)
                                      }
                                      onChange={val =>
                                        this.getFabricInfo(val, index)
                                      }
                                      placeholder="Find Fabric"
                                      // onFocus={() =>
                                      //   this.props.clearDummyFabric(index)
                                      // }
                                      options={
                                        fabricData.fabricList ||
                                        this.state.fabricList
                                      }
                                      // disabled={this.state.disabled}
                                      // onSelectResetsInput={false}
                                      // onBlurResetsInput={false}
                                    />
                 </div>

                                </div> */}
                                <MobileAppFields
                                  isFormGroup={true}
                                  inputType="select"
                                  label="Trim Category"
                                  inputName="trimCategory"
                                  value={
                                    index === 0 ? value.trimCategory : null
                                  }
                                  index={index}
                                  options={this.state.prefillInfo.TRIM.TRIMCATEGORY || []}
                                  onChange={this.updateSewingTrimData}
                                  // disabled={this.state.disabled}
                                />




                                {/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Fabric Name</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                                   {/* <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType={"text"}
                                                          inputName={"fabricName"}
                                                          label="Fabric Name"
                                                          value={fabricData.fabricName}
                                                           index={index}
                                                          // label={"comments"}
                                                          onChange={this.updateFabricName}
                                                          // disabled={this.state.disabled}
                                                          max={25}
                                                        /> */}

<div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Fabric ref no.</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                                      name="trimNumber"
                                      value={value.trimNumber}
                                      onInputChange={data =>
                                        this.getTrimRefNoSewing(
                                          value.trimCategory,
                                          data,
                                          index
                                        )
                                      }
                                      onChange={value =>
                                        this.getTrimInfoSewTrimData(
                                          value,
                                          index
                                        )
                                      }
                                      placeholder="Find trimRefNo"
                                      options={
                                        value.trimList ? value.trimList : []
                                      }
                                      // disabled={this.state.disabled}
                                      // onSelectResetsInput={false}
                                      // onBlurResetsInput={false}
                                    />
                 </div>

                                </div>



                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Position*</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                                {/* <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Position*"
                                                                    inputType="select"
                                                                    inputName="fabricPosition"
                                                                    value={fabricData.fabricPosition}
                                                                    options={this.state.prefillInfo.SAMPLEREQUEST.POSITION || []}
                                                                    index={index}
                                                                    onChange={this.updateFabric}
                                                                    // disabled={this.state.disabled}
                                                                  /> */}


                                        <MobileAppFields
                                                                            isFormGroup={true}
                                                                            label="Placement"
                                                                            inputType="select"
                                                                            inputName="placement"
                                                                            value={value.placement}
                                                                            index={index}
                                                                            options={this.state.prefillInfo.TRIMPLACEMENT || []}
                                                                            onChange={this.updateSewingTrimData}
                                                                            // disabled={this.state.disabled}
                                                                          />



                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Base No</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


{/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Base No</span>
                                  

                          <span className="completed-date-mdheader">
                          {  fabricData.bNumber ? fabricData.bNumber 
                              : "-"}
                          </span>

                                </div> */}

                                <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Type"
                                                                    inputType="select"
                                                                    inputName="type"
                                                                    value={value.type}
                                                                    index={index}
                                                                    options={[
                                                                      {
                                                                        label: "Both Elastic",
                                                                        value: "Both Elastic"
                                                                      },
                                                                      {
                                                                        label: "Top TTH / Bottom Elastic",
                                                                        value: "Top TTH / Bottom Elastic"
                                                                      }
                                                                    ]}
                                                                    onChange={this.updateSewingTrimData}
                                                                    // disabled={this.state.disabled}
                                                                  />



                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Classification of Fabric</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                {/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Classification of Fabric</span>
                                  
                          <span className="completed-date-mdheader">
                          {  fabricData.classificationOfFabric ? fabricData.classificationOfFabric 
                              : "-"}
                          </span>

                                </div> */}


                                                                  <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="No Of Rows"
                                                                    inputType="number"
                                                                    inputName="noOfRow"
                                                                    index={index}
                                                                    value={value.noOfRow}
                                                                    onChange={this.updateSewingTrimData}
                                                                    // disabled={this.state.disabled}
                                                                  />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Quality</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                {/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Quality</span>
                                    

                          <span className="completed-date-mdheader">
                          {  fabricData.quality ? fabricData.quality 
                              : "-"}
                          </span>

                                </div> */}


                                <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Length in cm"
                                                                    inputType="number"
                                                                    inputName="length"
                                                                    value={value.length}
                                                                    index={index}
                                                                    onChange={this.updateSewingTrimData}
                                                                    // disabled={this.state.disabled}
                                                                  />
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Count & Construction</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                {/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Count & Construction</span>
                                    

                          <span className="completed-date-mdheader">
                          {  fabricData.countAndConstruction ? fabricData.countAndConstruction 
                              : "-"}
                          </span>

                                </div> */}
                                <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Total Reqrd-mtrs"
                                                                    inputType="number"
                                                                    inputName="totalReq"
                                                                    value={value.totalReq}
                                                                    index={index}
                                                                    onChange={this.updateSewingTrimData}
                                                                    disabled={true}
                                                                  />

                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Fabric Origination</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                                                  {/* <MobileAppFields
                                                                    isFormGroup={true}
                                                                    label="Fabric Origination"
                                                                    inputType="select"
                                                                    inputName="fabricOrigination"
                                                                    value={fabricData.fabricOrigination}
                                                                    options={
                                                                      this.state.prefillInfo.SAMPLEREQUEST.FABRICORIGINATION || []
                                                                    }
                                                                    index={index}
                                                                    onChange={this.updateFabric}
                                                                    // disabled={this.state.disabled}
                                                                  /> */}

                                </div>
                                </React.Fragment>
                                ))}
                                    </React.Fragment>
                                  )}





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}


<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.sewing.comments}
                                              label={"Comments"}
                                              onChange={this.updateSewing1}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={this.createSewing}>Save</button>
                                  <button className="du-co" onClick={this.completeSewing}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      
      </div>
        )}


      {/* Marker */}
      {this.props.rights.sampleRequest.marker.web.edit && this.state.sampleRequest.toggle.marker &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isMarker")} style={{
            color: this.state.isMarker ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isMarker} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isMarker ? "600": "400"}}
          >
            Marker
          </span>
        <i className={`fa ${this.state.isMarker ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isMarker && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

<MbModuleHeader
                                  moduleName={"marker"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.marker}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                {/* <div style={{marginTop:"15px"}}>Upload <img src={addicon} alt="add" onClick={this.handleToggleUpload} style={{ cursor: "pointer" }} /></div> */}

                                {/* <div>
        {this.state.showUploadDiv ? (
          <div style={{}}>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">File name</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">File Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Add File</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>

                                <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div>

                                <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
                                  <button className="upl-btn">Add File</button>
                                  <button className="upl-btn" onClick={this.handleCancelUpload}>Cancle</button>
                                </div>
          </div>
        ) : (
          <div style={{ padding: "15px", border: "1px solid #ccc", borderRadius: "5px", marginTop: "10px",height:"80px" }}>
          </div>
        )}
      </div> */}
      <MobileFileUpload
        getRefImages={refImages =>
          this.getRefImages(refImages, "marker")
        }
        moduleName={"marker"}
        Heading="Upload Images"
        uploadedDocs={this.state.sampleRequest.marker.refImages ? this.state.sampleRequest.marker.refImages : null}
        imageTypeOption={[]}
      />









                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}

                                          <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.marker.comments}
                                              label={"Comments"}
                                              onChange={this.updateMarker}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.createMarker(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completeMarker(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}






        {/* Embellishment */}
        {this.props.rights.sampleRequest.embellishment.web.edit && this.state.sampleRequest.toggle.embellishment &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isEmbellishment")} style={{
            color: this.state.isEmbellishment ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isEmbellishment} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isEmbellishment ? "600": "400"}}
          >
            Embellishment
          </span>
        <i className={`fa ${this.state.isEmbellishment ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isEmbellishment && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}
                                <MbModuleHeader
                                  moduleName={"embellishment"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.embellishment}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div className="fabricaddbutton">
                                  <img src={addicon} alt="add" onClick={() => this.addEmb()} />
                                </div>

                                {this.state.sampleRequest.embellishment.map((embellishment, index) => (
          <div key={""} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.removeEmb(index)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Type</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="select"
                                                          inputName="embType"
                                                          value={embellishment.embType}
                                                          options={this.state.prefillInfo.SAMPLEREQUEST.TYPE}
                                                          onChange={this.updateEmbellishment}
                                                          index={index}
                                                          label={"Type "}
                                                          // disabled={this.state.disabled}
                                                        />
                          
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">HH:MM</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="time"
                                                          inputName="hoursMinutes"
                                                          value={embellishment.hoursMinutes}
                                                          onChange={this.updateEmbellishment}
                                                          index={index}
                                                          label={"HH:MM"}
                                                          // disabled={this.state.disabled}
                                                        />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Price/30mins</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                                        <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="text"
                                                          inputName="pricePerHalfHour"
                                                          label={"Price/30mins"}
                                                          value={embellishment.pricePerHalfHour}
                                                          onChange={this.updateEmbellishment}
                                                          index={index}
                                                          // disabled={this.state.disabled}
                                                        />
                                </div>

                              

                                </div>
                                 ))}





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}

                                        <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"embellishmentComments"}
                                              value={this.state.sampleRequest.embellishmentComments}
                                              label={"Comments"}
                                              onChange={this.updateSampleRequest}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.createEmbellishment(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completeEmbellishment(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
        )}



      {/* Embroidery */}
      {this.props.rights.sampleRequest.embroidery.web.edit && this.state.sampleRequest.toggle.embroidery &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isEmbroidery")} style={{
            color: this.state.isEmbroidery ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isEmbroidery} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isEmbroidery ? "600": "400"}}
          >
            Embroidery
          </span>
        <i className={`fa ${this.state.isEmbroidery ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isEmbroidery && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

<MbModuleHeader
                                  moduleName={"embroidery"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.embroidery}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"20px"}}>
                                <div className="emp-top-ch">
                                  <div className="flex-gap-10" >
                                    <input type="checkbox" name="" id="" checked={this.state.sampleRequest.embroidery.cutPanel}  style={{position:"static",opacity:"1",marginTop:"0px"}} onChange={e => this.updateEmbroidery("cutPanel", e.target.checked)} />
                                    <span className="label1" style={{marginBottom:"0px"}}>Cut Panel</span>
                                  </div>
                                  <div className="flex-gap-10">
                                  <input type="checkbox" checked={this.state.sampleRequest.embroidery.garmentForm} name="" id="filled-in-box1"  style={{position:"static",opacity:"1",marginTop:"0px"}} onChange={e => this.updateEmbroidery("garmentForm", e.target.checked)}/>
                                  <span className="label1" id="filled-in-box1" style={{marginBottom:"0px"}}> Garment Form</span>
                                  </div>
                                </div>

                                <div className="emp-top-ch">
                                <div className="flex-gap-10">
                                    <input type="checkbox" name="" id="" checked={this.state.sampleRequest.embroidery.allOver}  style={{position:"static",opacity:"1",marginTop:"0px"}} onChange={e => this.updateEmbroidery("allOver", e.target.checked)}/>
                                    <span className="label1" style={{marginBottom:"0px"}}>All Over</span>
                                  </div>
                                  <div className="flex-gap-10">
                                  <input type="checkbox" name="" id="" checked={this.state.sampleRequest.embroidery.semiGarmentForm}  style={{position:"static",opacity:"1",marginTop:"0px"}}  onChange={e => this.updateEmbroidery("semiGarmentForm", e.target.checked)}/>
                                  <span className="label1" style={{marginBottom:"0px"}}>Semi Garment Form</span>
                                  </div>
                                </div>
                                </div>
                                <div className="flex-gap-10" style={{marginTop:"10px"}}>
                                <input type="checkbox" name="" id="" checked={this.state.sampleRequest.embroidery.tassel}  style={{position:"static",opacity:"1",marginTop:"0px"}}  onChange={e => this.updateEmbroidery("tassel", e.target.checked)}/>
                                  <span className="label1" style={{marginBottom:"2px"}}>Tassle</span>
                                  </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginBottom:"20px",marginTop:"20px"}}>
                                <div className="" style={{flex:"1"}}>
                          <select
                           id="mySelect"
                           onDoubleClick={() => this.moveToRight()}
                          //  className="mySelectLeft"
                          style={{ display: "block" ,width:"80%",border:"1px solid",borderRadius:"4px",padding:"10px" }}
                           size="10"
                           disabled={this.state.disabled}
                          >
                            
                            {this.state.sampleRequest.embroidery.leftData.map((data) => {
                              return <option style={{marginBottom:"4px"}}>{data}</option>
                            })}
                          </select>
                        </div>
                        {/* end of process-alloc-con */}
                        { <div className="up-down-btn">
                          <a onClick={() => this.moveToRight()}>
                            <span className="up1">
                              <i className="fa fa-chevron-right" />
                            </span>
                          </a>
                          <a onClick={() => this.moveToLeft()}>
                            
                            <span className="down1"  >
                              <i className="fa fa-chevron-left" />
                            </span>
                          </a>
                        </div>}
                        </div>


                                <div className="" style={{display:"flex",justifyContent:"space-between",marginBottom:"20px"}}>
                        
                        <div className="" style={{flex:"1"}}>
                          <select
                            id="mySelect2"
                            onDoubleClick={() => this.moveToLeft()}
                            // onDoubleClick={}
                            // className="mySelectRight"
                            size="10"
                            style={{ display: "block" ,width:"80%",border:"1px solid",borderRadius:"4px",padding:"10px" }}
                            // disabled={this.state.disabled}
                          >
                           
                            {this.state.sampleRequest.embroidery.rightData.map((data) => {
                              return <option style={{marginBottom:"4px"}}>{data}</option>
                            })}
                          </select>
                        </div>
                        {/* end of process-alloc-con */}
                        { <div className="up-down-btn">
                          <a onClick={() => this.moveToUp()}>
                            <span className="up1">
                              <i className="fa fa-chevron-up" />
                            </span>
                          </a>
                          <a onClick={() => this.moveToBottom()}>
                          <span className="down1">
                              <i className="fa fa-chevron-down" />
                            </span>
                          </a>
                        </div>}
                      </div>










                                


                                {/* <div>
                                <div style={{marginTop:"15px"}}>Upload <img src={addicon} alt="add" onClick={this.handleToggleUpload} style={{ cursor: "pointer" }} /></div>
        {this.state.showUploadDiv ? (
          <div style={{}}>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">File name</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">File Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Add File</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>

                                <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div>

                                <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
                                  <button className="upl-btn">Add File</button>
                                  <button className="upl-btn" onClick={this.handleCancelUpload}>Cancle</button>
                                </div>
          </div>
        ) : (
          <div style={{ padding: "15px", border: "1px solid #ccc", borderRadius: "5px", marginTop: "10px",height:"80px" }}>
          </div>
        )}
      </div> */}
      <div style={{display:"flex"}}>

<MobileFileUpload
        Heading="Upload Images"
        getRefImages={(refImages) => this.getRefImages(refImages, 'embroidery')}
        // disabled={this.state.disabled}
        uploadedDocs={this.state.sampleRequest.embroidery.refImages.length > 0 ? this.state.sampleRequest.embroidery.refImages : null}
      />
      </div>

<div>
      <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>
      Backing
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      value={this.state.sampleRequest.embroidery.backing}
                      checked={this.state.sampleRequest.embroidery.backing}
                      onChange={(e)=>this.updateEmbroidery("backing", e.target.checked,)}
                      // checked={true}
                      // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>

                                  </div>

                                  {this.state.sampleRequest.embroidery.backing &&
                                  <div className="fabricaddbutton" style={{gap:"10px"}}>
                                    Backing
                                  <img src={addicon} alt="add" onClick={() => this.changeBackingArray('add')} />
                                </div>}

                                {this.state.sampleRequest.embroidery.backing && this.state.sampleRequest.embroidery.backingData.map((backingData, i) => (
          <div key={""} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.changeBackingArray('clear', i)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Type</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                              isFormGroup={true}
                                                              inputType="select"
                                                              inputName="backingType"
                                                              value={backingData.backingType}
                                                              options={this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                                                .BACKINGTYPE}
                                                              onChange={(name, value) => this.updateEmbroideryBackingData(name, value, i)}
                                                              label={"Backing "}
                                                              // disabled={this.state.disabled}
                                                            />

                                                            <MobileAppFields
                                                                                          isFormGroup={true}
                                                                                          inputType="text"
                                                                                          inputName="width"
                                                                                          value={backingData.width}
                                                                                          // options={this.state.widthList}
                                                                                          onChange={(name, value) => this.updateEmbroideryBackingData(name, value, i)}
                                                                                          label={"Width"}
                                                                                          disabled={this.state.disabled}
                                                                                        />
                          
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
                                       <MobileAppFields
                                                                     isFormGroup={true}
                                                                     inputType="select"
                                                                     inputName="placement"
                                                                     value={backingData.placement}
                                                                     options={this.state.prefillInfo.SAMPLEREQUEST
                                                                      .PLACEMENT_EMB}
                                                                     onChange={(name, value) => this.updateEmbroideryBackingData(name, value, i)}
                                                                     label={"Placement "}
                                                                     disabled={this.state.disabled}
                                                                   />                           
                                </div>
                                </div>
                                ))}

                                  








                                <div className="fabricaddbutton">
                                  <img src={addicon} alt="add" onClick={this.addEmbroideryData} />
                                </div>

                                {this.state.sampleRequest.embroidery.embroideryData.map((embroideryData, i) => (
          <div key={i} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.props.removeEmbroideryData(i)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Emb Placement</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                 <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Emb Placement"
                                                                  inputType="select"
                                                                  inputName="embPlacement"
                                                                  value={embroideryData.embPlacement}
                                                                  options={this.state.prefillInfo.SAMPLEREQUEST
                                                                    .PLACEMENT_EMB}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  // disabled={this.state.disabled}
                                                                />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Emb Form</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Emb Form"
                                                                  inputType="select"
                                                                  inputName="embForm"
                                                                  value={embroideryData.embForm}
                                                                  options={ this.state.prefillInfo.SAMPLEREQUEST.EMBFORM}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  // disabled={this.state.disabled}
                                                                />
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">No of Colors</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label={"No of Colors"}
                                                                  inputType="select"
                                                                  inputName="noOfCols"
                                                                  value={embroideryData.noOfCols}
                                                                  options={this.state.prefillInfo.SAMPLEREQUEST
                                                                    .NOOFCOLORS}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  // disabled={this.state.disabled}
                                                                />


                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Frames</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Frames"
                                                                  inputType="select"
                                                                  inputName="frames"
                                                                  value={embroideryData.frames}
                                                                  options={this.state.prefillInfo.SAMPLEREQUEST.FRAMES}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  // disabled={this.state.disabled}
                                                                />

                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Stitches/Mtr</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Stitches/Mtr"
                                                                  inputType="text"
                                                                  inputName="stitchesMtr"
                                                                  value={embroideryData.stitchesMtr}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  disabled={ (embroideryData.embForm && embroideryData.embForm.toLowerCase() === "panel")}
                                                                />

                                
                                <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Consumption/Unit</span>
                                    <div className="input-qr">
                                    <input size={"6"} maxLength={"6"} type="text" name="consumption" value={embroideryData.consumption} className="input1" 
                                  disabled={(embroideryData.embForm && embroideryData.embForm.toLowerCase() === "panel")}
                                  onChange={(e) => this.updateEmbroideryData(e.target.name, e.target.value, i)}
                                />
                                </div>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Stitches Count</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Stitches Count"
                                                                  inputType="text"
                                                                  inputName="stitchCount"
                                                                  value={embroideryData.stitchCount}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  // disabled={this.state.disabled || embroideryData.embForm == "length"}
                                                                  // disabled={this.state.disabled}
                                                                />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Price/1000 Stitches</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                                  isFormGroup={true}
                                                                  label="Price/1000 Stitches"
                                                                  inputType="text"
                                                                  inputName="priceForStitches"
                                                                  value={embroideryData.priceForStitches}
                                                                  // options={this.state.PRICE1000STICHES&&this.state.PRICE1000STICHES.map(x => ({ label: x, value: x }))}
                                                                  onChange={(name, value) => this.updateEmbroideryData(name, value, i)}
                                                                  // disabled={this.state.disabled}
                                                                // disabled={this.state.disabled || embroideryData.embForm == "length"}
                                                                />
                                </div>

                                </div>
                                 ))}





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}
                                <MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.embroidery.comments}
                                              label={"Comments"}
                                              onChange={this.updateEmbroidery}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.saveEmbroidery(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completeEmbroidery(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}




      {/* Wash */}
      {this.props.rights.sampleRequest.wash.web.edit && this.state.sampleRequest.toggle.wash &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isWash")} style={{
            color: this.state.isWash ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isWash} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isWash ? "600": "400"}}
          >
            Wash
          </span>
        <i className={`fa ${this.state.isWash ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isWash && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                                <MbModuleHeader
                                  moduleName={"wash"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.wash}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Pattern Master Name</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


{/* <div className="select-qr" style={{width:"100%"}}>
                                    <span className="label1">Pattern Master Name</span>
                                    <div className="mobileAppAsync" style={{width:"100%"}}> 
                                    <Async
                  name="patternMaster"
                  value={this.state.sampleRequest.pattern.patternMaster}
                  // onInputChange={e =>
                  //   this.getPatternMaster(e, "patternMaster")
                  // }
                  onChange={value =>
                    this.updatePattern(
                      "patternMaster",
                      value.value
                    )
                  }
                  placeholder="Find Pattern Master "
                  options={this.state.prefillInfo.PATTERNMASTER}
                  // disabled={this.state.disabled}
                  // onSelectResetsInput={false}
                  // onBlurResetsInput={false}
                />
                 </div>

                                </div> */}


                                <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="select"
                                                          inputName="washType"
                                                          value={this.state.sampleRequest.wash.washData.washType}
                                                          options={this.state.prefillInfo.WASH.WASHTYPE}
                                                          // index={index}
                                                          label={"Wash Type"}
                                                          onChange={this.updateWash1}
                                                          // disabled={this.state.disabled}
                                                        />



                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Pattern Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}

                                {/* <MobileAppFields
                                                              isFormGroup={true}
                                                              label="Pattern Type"
                                                              inputType="select"
                                                              inputName="patternType"
                                                              value={this.state.sampleRequest.pattern.patternType}
                                                              options={this.state.prefillInfo.PATTERNTYPE || []}
                                                              onChange={this.updatePattern}
                                                              // disabled={this.state.disabled}
                                                            /> */}


                                                            <MobileAppFields
                                                                                      isFormGroup={true}
                                                                                      inputType="select"
                                                                                      inputName="washFrom"
                                                                                      value={this.state.sampleRequest.wash.washData.washFrom}
                                                                                      options={this.state.prefillInfo.WASH.WASHFORM}
                                                                                      // index={index}
                                                                                      label={"Wash Form"}
                                                                                      onChange={this.updateWash1}
                                                                                      // disabled={this.state.disabled}
                                                                                    />
                                </div>








                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Block Ref Used</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}
                                <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="select"
                                                          inputName="laundryUnit"
                                                          value={this.state.sampleRequest.wash.washData.laundryUnit}
                                                          options={this.state.prefillInfo.WASH.LAUNDRYUNIT}
                                                          // index={index}
                                                          label={"Laundry Unit"}
                                                          onChange={this.updateWash1}
                                                          // disabled={this.state.disabled}
                                                        />


                                {/* <MobileAppFields
                                                              isFormGroup={true}
                                                              label="Block Ref Used"
                                                              inputType="text"
                                                              inputName="blockRefNumber"
                                                              value={this.state.sampleRequest.pattern.blockRefNumber}
                                                              onChange={this.updatePattern}
                                                              // disabled={this.state.disabled}
                                                            /> */}
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Approval Status</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div> */}


                                <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="number"
                                                          inputName="price"
                                                          value={this.state.sampleRequest.wash.washData.price}
                                                          // index={index}
                                                          label={"Price/Kg"}
                                                          // options={this.state.PRICEPERKG&&this.state.PRICEPERKG.map(x=>({label:x.label,value:x.label}))}
                                                          onChange={this.updateWash1}
                                                          // disabled={this.state.disabled}
                                                        />
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}}>
                                MOCKS ?
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      name="hasMock"
                      value={this.state.sampleRequest.wash.hasMock}
                      onChange={e => this.updateWash("hasMock", e.target.checked,) }
                      checked={this.state.sampleRequest.wash.hasMock}
                      // checked={true}
                      // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>





                                  <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
                                    <MobileAppFields
                                                          isFormGroup={true}
                                                          inputType="select"
                                                          inputName="numberOfMocks"
                                                          value={this.state.sampleRequest.wash.numberOfMocks}
                                                          options={this.state.prefillInfo.WASH.NOOFMOCKS}
                                                          label={"No. Of Mocks"}
                                                          onChange={this.updateWash}
                                                          // disabled={this.state.disabled}
                                                        />
                                  </div>


                                  <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}}>
                                  Tacking
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      name="tacking"
                      value={this.state.sampleRequest.wash.tacking}
                      onChange={e => this.updateWash("tacking", e.target.checked,) }
                      checked={this.state.sampleRequest.wash.tacking}
                      // checked={true}
                      // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>



                                  <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}}>
                                  Recipe
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      name="recipe"
                      value={this.state.sampleRequest.wash.recipe}
                      onChange={e => this.updateWash("recipe", e.target.checked,) }
                      checked={this.state.sampleRequest.wash.recipe}
                      // checked={true}
                      // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>


                                  <MobileFileUpload
                                      Heading="Upload Images"
                                      moduleName={"marker"}
                                      getRefImages={refImages =>
                                        this.getRefImages(refImages, "wash")
                                      }
                                      // disabled={this.state.disabled}
                                      uploadedDocs={this.state.sampleRequest.wash.refImages ? this.state.sampleRequest.wash.refImages : null}
                                      imageTypeOption={[]}
                                    />
                          





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}


<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.wash.comments}
                                              label={"Comments"}
                                              onChange={this.updateWash}
                                            />  




                                <div className="sa-co-btn">
                                  <button className="du-sav"onClick={e => this.createWash(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completeWash(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}






        {/* Dispatch */}
        {this.props.rights.sampleRequest.dispatch.web.edit && this.state.sampleRequest.toggle.dispatch &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isDispatch")} style={{
            color: this.state.isDispatch ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isDispatch} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isDispatch ? "600": "400"}}
          >
            Dispatch
          </span>
        <i className={`fa ${this.state.isDispatch ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isDispatch && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

<MbModuleHeader
                                  moduleName={"dispatch"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.dispatch}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />


<div style={{display:"flex",justifyContent:"space-between",marginTop:"15px",alignItems:"end"}}>
Magnum Counter
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                      type="checkbox"
                      name="magnumCounter"
                      value={this.state.sampleRequest.dispatch.magnumCounter}
                      onChange={e => this.updateDispatch("magnumCounter", e.target.checked,) }
                      checked={this.state.sampleRequest.dispatch.magnumCounter}
                      // checked={true}
                      // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>


                                <div className="fabricaddbutton">
                                  <img src={addicon} alt="add" onClick={this.addDispatchData} />
                                </div>

                                {this.state.sampleRequest.dispatch.data.length > 0 &&
                              this.state.sampleRequest.dispatch.data.map((val, i) => (
          <div key={i} style={{ marginBottom: "15px" }}>
            <div className="fabricremovebutton">
                                  <img src={removeicon} alt="remove" onClick={() => this.removeDispatchData(i)} />
                                </div>
                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Date</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                <MobileAppFields
                                                                      durationETA={!val.date ? -1 : null}
                                                                      isFormGroup={true}
                                                                      inputType="date"
                                                                      inputName="date"
                                                                      label="Date"
                                                                      value={val.date}
                                                                      onChange={(name, value) =>
                                                                        this.udpateDispatchValues(
                                                                          name,
                                                                          value,
                                                                          i
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Location</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                <MobileAppFields
                                                                      isFormGroup={true}
                                                                      inputType="select"
                                                                      inputName="location"
                                                                      value={val.location}
                                                                      options={this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                                                        .LOCATION}
                                                                      label={"Location"}
                                                                      onChange={(name, value) =>
                                                                        this.udpateDispatchValues(
                                                                          name,
                                                                          value,
                                                                          i
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">AWB No.</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                <MobileAppFields
                                                                      isFormGroup={true}
                                                                      inputType="text"
                                                                      inputName="awbNumber"
                                                                      value={val.awbNumber}
                                                                      label={"AWB No."}
                                                                      onChange={(name, value) =>
                                                                        this.udpateDispatchValues(
                                                                          name,
                                                                          value,
                                                                          i
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />



                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Courier</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}
                                <MobileAppFields
                                                                      isFormGroup={true}
                                                                      inputType="select"
                                                                      inputName="courier"
                                                                      value={val.courier}
                                                                      options={this.state.prefillInfo.SYSTEMSAMPLEREQUEST
                                                                        .COURIER}
                                                                      label={"Courier"}
                                                                      onChange={(name, value) =>
                                                                        this.udpateDispatchValues(
                                                                          name,
                                                                          value,
                                                                          i
                                                                        )
                                                                      }
                                                                      disabled={this.state.disabled}
                                                                    />

                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Size</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}


                                <MobileAppFields
                                                                      isFormGroup={true}
                                                                      inputType="select"
                                                                      inputName="size"
                                                                      value={val.size}
                                                                      options={this.state.sizeList}
                                                                      label={"Size"}
                                                                      onChange={(name, value) =>
                                                                        this.udpateDispatchValues(
                                                                          name,
                                                                          value,
                                                                          i
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                {/* <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Qty</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div> */}

                                <MobileAppFields
                                                                      isFormGroup={true}
                                                                      inputType="number"
                                                                      inputName="quantity"
                                                                      value={val.quantity}
                                                                      label={"Qty"}
                                                                      onChange={(name, value) =>
                                                                        this.udpateDispatchValues(
                                                                          name,
                                                                          value,
                                                                          i
                                                                        )
                                                                      }
                                                                      // disabled={this.state.disabled}
                                                                    />
                                </div>

                               

                                </div>
                                 ))}





                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}


<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.dispatch.comments}
                                              label={"Comments"}
                                              onChange={this.udpateDispatch}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.createDispatch(e)}>Save</button>
                                  <button className="du-co"  onClick={e => this.completeDispatch(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
        )}



      {/* Garding */}
      {this.props.rights.sampleRequest.QC.web.edit && this.state.sampleRequest.toggle.qc &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isGrading")} style={{
            color: this.state.isGrading ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isGrading} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isGrading ? "600": "400"}}
          >
            Grading
          </span>
        <i className={`fa ${this.state.isGrading ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isGrading && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}

                                <MbModuleHeader
                                  moduleName={"qc"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.qc}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px"}}>
                                Any Issue
                                  <label className="switch">
                    <input
                    style={{position:"static",opacity:"1"}}
                    type="checkbox"
                    name="anyIssue"
                    value={this.state.sampleRequest.qc.anyIssue}
                    onChange={e => this.updateQc("anyIssue", e.target.checked,) }
                    checked={this.state.sampleRequest.qc.anyIssue}
                    // checked={true}
                    // onChange={true}
                    />
                    <span className="slider round"></span>
                    </label>
                                  </div>

                                {this.state.sampleRequest.qc.anyIssue &&(
                                  <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            
                                  <MobileAppFields
                                     isFormGroup={true}
                                     inputType="text"
                                     inputName="reason"
                                     value={this.state.sampleRequest.qc.reason}
                                     label={"if yes, reason"}
                                     onChange={this.updateQc}
                                    />
                                </div>
                                )}


                                {/* <div style={{marginTop:"15px"}}>Upload <img src={addicon} alt="add" onClick={this.handleToggleUpload} style={{ cursor: "pointer" }} /></div> */}

                                {/* <div>
        {this.state.showUploadDiv ? (
          <div style={{}}>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">File name</span>
                                    <div className="input-qr">
                                <input type="text" className="input1" />
                                </div>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">File Type</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Add File</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>

                                <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div>

                                <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
                                  <button className="upl-btn">Add File</button>
                                  <button className="upl-btn" onClick={this.handleCancelUpload}>Cancle</button>
                                </div>
          </div>
        ) : (
          <div style={{ padding: "15px", border: "1px solid #ccc", borderRadius: "5px", marginTop: "10px",height:"80px" }}>
          </div>
        )}
      </div> */}



<MobileFileUpload
        Heading="Upload Images"
        moduleName={"marker"}
        getRefImages={refImages =>
          this.getRefImages(refImages, "qc")
        }
        // disabled={this.state.disabled}
        uploadedDocs={this.state.sampleRequest.qc.refImages.length > 0 ? this.state.sampleRequest.qc.refImages : null}
        imageTypeOption={[]}
      />








                                {/* <div className="comments">
                                Comments
                                <textarea name="" id="" className="com-txt"></textarea>
                                </div> */}

<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"comments"}
                                              value={this.state.sampleRequest.qc.comments}
                                              label={"Comments"}
                                              onChange={this.updateQc}
                                            />  



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={e => this.createQC(e)}>Save</button>
                                  <button className="du-co" onClick={e => this.completeQC(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}






      {/* Costing */}
      {this.props.rights.sampleRequest.costing.web.edit && this.state.sampleRequest.toggle.costing &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isCosting")} style={{
            color: this.state.isCosting ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isCosting} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isCosting ? "600": "400"}}
          >
            Costing
          </span>
        <i className={`fa ${this.state.isCosting ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isCosting && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}
                                <MbModuleHeader
                                  moduleName={"costing"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.costing}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />




<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"costingComments"}
                                              value={this.state.sampleRequest.costingComments}
                                              label={"Comments"}
                                              onChange={this.updateSampleRequest}
                                              style={{marginTop:"10px"}}
                                            /> 

                              



                                <div className="sa-co-btn">
                                <button className="du-sav" onClick={e=>this.createCosting(e)}>Save</button>
                                <button className="du-co" onClick={e=>this.completeCosting(e)}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}




      {/* Sign Off */}
      {this.props.rights.sampleRequest.signoff.web.edit && this.state.sampleRequest.toggle.signOff &&(
      <div className="main-dropdown">
        <div className="md-brbox" onClick={()=>this.handleToggleDropdown("isSignOff")} style={{
            color: this.state.isSignOff ? "rgba(0, 150, 136, 1)" : "black",
          }}>
        <span 
            ref={this.textRefs.isSignOff} 
            tabIndex={-1} // Makes the span focusable programmatically
            style={{outline:"none", fontWeight: this.state.isSignOff ? "600": "400"}}
          >
            Sign Off
          </span>
        <i className={`fa ${this.state.isSignOff ? "fa-angle-up" : "fa-angle-down"} font-icon`} />
        </div>
        {this.state.isSignOff && (
          <React.Fragment>
            {/* <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Assigned To</span>
                                    <select class="dropdown1">
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Status</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div>

                                <div style={{display:"flex",justifyContent:"space-between",marginTop:"5px",gap:"10px"}}>
            <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">ETA Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                <div className="select-qr" style={{flex:"1"}}>
                                    <span className="label1">Completed Date</span>
                                    <select class="dropdown1" >
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    </select>

                                </div>
                                </div> */}
                                <MbModuleHeader
                                  moduleName={"signOff"}
                                  _id={this.state._id}
                                  process={this.state.sampleRequest && this.state.sampleRequest.processUpdates && this.state.sampleRequest.processUpdates.signOff}
                                  statusList={this.state.prefillInfo.STATUS}
                                  updateModulesMain={this.updateModulesMain}
                                  
                                  />




<MobileAppFields
                                              isFormGroup={true}
                                              inputType={"textarea"}
                                              inputName={"signOffComments"}
                                              value={this.state.sampleRequest.signOffComments}
                                              label={"Comments"}
                                              onChange={this.updateSampleRequest}
                                            /> 

                              



                                <div className="sa-co-btn">
                                  <button className="du-sav" onClick={this.createSignOff}>Save</button>
                                  <button className="du-co" onClick={this.completeSignoff}>Complete</button>
                                </div>
          </React.Fragment>
        )}
      </div>
      )}







                </div>


            </div>
        );
    }
}


const mapStateToProps = state => {
  return {
      toggle: state.Header.toggle,  // Getting 'toggle' from 'Header' slice of state
      rights: state.main.rights     // Getting 'rights' from 'main' slice of state
  }
}

export default withRouter(connect(mapStateToProps)(SampleMobileApp));

// export default SampleMobileApp;


// WEBPACK FOOTER //
// ./src/pages/Sample/SampleMobileApp/SampleMobileApp.js